function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ManagerTemplate = require('./manager.template');
var ManagerHeaderTemplate = require('./manager-header.template');
var ManagerScrollFooterTemplate = require('./manager-scroll-footer.template');
var ManagerLoadMore = require('./manager-load-more');
var TweetTemplate = require('./tweet.template');
var SaitoImageOverlay = require('../../../lib/saito/ui/saito-image-overlay/saito-image-overlay');
var SCROLL_THRESHOLD_PX = 240;
var Manager = /*#__PURE__*/function () {
  function Manager(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, Manager);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.mode = 'timeline';
    this.active_signature = '';
    this.active_thread_id = '';
    this.active_profile_key = '';
    this.timeline_rendered = false;
    this.notifications_rendered = false;
    this.scroll_positions = {
      timeline: 0,
      notifications: 0,
      thread: 0,
      posts: 0,
      replies: 0,
      likes: 0
    };
    this.pagination = this.createPaginationState();
    this.pending_newer_tweets = [];
    this._timeline_bootstrapping = false;
    this._peer_history_pending = false;
    this._peer_timeline_refreshes = 0;
    this._load_more_timer = null;
    this._notifications_bootstrapping = false;
    this.pending_route_signature = '';
    this.permalink_state = null;
    this._route_load_signature = '';
    this._route_load = null;
    this._route_refresh_pending = false;
    this._browser_history_bound = false;
    this.image_overlay = null;
    this.profile_cache = {};
    this._read_observer = null;
    this._read_observer_root = null;
    this._read_save_timer = null;
    this._last_scroll_top = 0;
    this._scroll_container = null;
    this._scroll_handler = null;
    this.scroll_raf = null;

    // Per-view Manager chrome. Header is navigation only (back + title).
    // Home / notifications / user-content (posts/replies/likes) omit sticky chrome.
    // Thread keeps the pinned header for back navigation.
    this.viewChrome = {
      timeline: {
        header: false
      },
      notifications: {
        header: false
      },
      thread: {
        header: true
      },
      posts: {
        header: false
      },
      replies: {
        header: false
      },
      likes: {
        header: false
      }
    };
  }
  return _createClass(Manager, [{
    key: "createPaginationState",
    value: function createPaginationState() {
      return {
        timeline: {
          batchSize: 5,
          loading: false,
          exhausted: false,
          error: null,
          mockPage: 0
        },
        notifications: {
          cursor: 0,
          batchSize: 2,
          loading: false,
          exhausted: false,
          mockPage: 0
        },
        thread: {
          cursor: 0,
          batchSize: 2,
          loading: false,
          exhausted: false,
          mockPage: 0,
          chain: []
        },
        posts: {
          cursor: 0,
          batchSize: 20,
          loading: false,
          exhausted: false,
          error: null
        },
        replies: {
          cursor: 0,
          batchSize: 20,
          loading: false,
          exhausted: false,
          error: null
        },
        likes: {
          cursor: 0,
          batchSize: 20,
          loading: false,
          exhausted: false,
          error: null
        }
      };
    }
  }, {
    key: "renderTimeline",
    value: function renderTimeline() {
      var _this$mod$main, _this$mod$main$showPr;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$updateHistory = _ref.updateHistory,
        updateHistory = _ref$updateHistory === void 0 ? true : _ref$updateHistory,
        _ref$scrollToTop = _ref.scrollToTop,
        scrollToTop = _ref$scrollToTop === void 0 ? false : _ref$scrollToTop;
      var previousMode = this.mode;
      this.clearPermalinkState();
      this.saveScrollPosition(previousMode);
      if (scrollToTop) {
        this.scroll_positions.timeline = 0;
      }
      this.mode = 'timeline';
      this.active_signature = '';
      this.active_thread_id = '';
      this.active_profile_key = '';
      if (updateHistory) {
        this.replaceTweetLocation();
      }
      (_this$mod$main = this.mod.main) === null || _this$mod$main === void 0 || (_this$mod$main$showPr = _this$mod$main.showProfile) === null || _this$mod$main$showPr === void 0 || _this$mod$main$showPr.call(_this$mod$main, this.mod.publicKey);
      this.render();
      if (previousMode !== 'timeline') {
        this.resetMenuToHome();
      }
      this.restoreScrollPosition('timeline');
      this.syncScrollFooter();
      this.syncPendingNewerTweets();
    }
  }, {
    key: "renderHome",
    value: function renderHome() {
      var scrollToTop = this.mode === 'timeline';
      this.pending_route_signature = '';
      this.replaceTweetLocation({
        force: true
      });
      this.renderTimeline({
        updateHistory: false,
        scrollToTop: scrollToTop
      });
    }
  }, {
    key: "renderNotifications",
    value: function renderNotifications() {
      var _this$mod$markNotific, _this$mod, _this$mod$main2, _this$mod$main2$showP;
      this.clearPermalinkState();
      this.saveScrollPosition();
      (_this$mod$markNotific = (_this$mod = this.mod).markNotificationsViewed) === null || _this$mod$markNotific === void 0 || _this$mod$markNotific.call(_this$mod);
      this.mode = 'notifications';
      this.active_signature = '';
      this.active_thread_id = '';
      this.active_profile_key = '';
      (_this$mod$main2 = this.mod.main) === null || _this$mod$main2 === void 0 || (_this$mod$main2$showP = _this$mod$main2.showProfile) === null || _this$mod$main2$showP === void 0 || _this$mod$main2$showP.call(_this$mod$main2, this.mod.publicKey);
      this.replaceTweetLocation();
      this.render();
      this.restoreScrollPosition('notifications');
      this.syncScrollFooter();
    }
  }, {
    key: "renderThread",
    value: function renderThread(signature) {
      var _this$mod$main3, _this$mod$main3$showP;
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$updateHistory = _ref2.updateHistory,
        updateHistory = _ref2$updateHistory === void 0 ? true : _ref2$updateHistory;
      var previousMode = this.mode;
      this.clearPermalinkState();
      this.saveScrollPosition();
      var tweet = this.mod.getTweet(signature);
      this.mode = 'thread';
      this.active_signature = signature || '';
      this.active_thread_id = tweet ? tweet.thread_id || tweet.signature : '';
      this.active_profile_key = '';
      (_this$mod$main3 = this.mod.main) === null || _this$mod$main3 === void 0 || (_this$mod$main3$showP = _this$mod$main3.showProfile) === null || _this$mod$main3$showP === void 0 || _this$mod$main3$showP.call(_this$mod$main3, this.mod.publicKey);
      this.scroll_positions.thread = 0;
      if (updateHistory && signature && typeof window !== 'undefined') {
        var url = this.mod.returnTweetUrl(signature);
        var state = {
          redsquareView: 'thread',
          signature: signature
        };
        if (previousMode === 'thread') {
          window.history.replaceState(state, '', url);
        } else {
          window.history.pushState(state, '', url);
        }
      }
      this.resetThreadPagination(signature);
      this.render();
      this.restoreScrollPosition('thread');
      this.syncScrollFooter();
    }
  }, {
    key: "renderPosts",
    value: function renderPosts() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.renderProfileView('posts', publicKey, options);
    }
  }, {
    key: "renderReplies",
    value: function renderReplies() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.renderProfileView('replies', publicKey, options);
    }
  }, {
    key: "renderLikes",
    value: function renderLikes() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.renderProfileView('likes', publicKey, options);
    }
  }, {
    key: "renderProfileView",
    value: function renderProfileView(mode) {
      var _this$mod$main4, _this$mod$main4$showP;
      var publicKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref3$updateHistory = _ref3.updateHistory,
        updateHistory = _ref3$updateHistory === void 0 ? true : _ref3$updateHistory;
      var previousMode = this.mode;
      var previousProfileKey = this.active_profile_key;
      this.clearPermalinkState();
      this.saveScrollPosition();
      this.mode = mode;
      this.active_signature = '';
      this.active_thread_id = '';
      this.active_profile_key = publicKey || this.mod.publicKey || '';
      this.scroll_positions[mode] = 0;
      if (updateHistory && typeof window !== 'undefined') {
        var state = {
          redsquareView: 'profile',
          publicKey: this.active_profile_key,
          tab: mode
        };
        var url = this.mod.returnUserUrl(this.active_profile_key);
        if (this.isProfileViewMode(previousMode) && previousProfileKey === this.active_profile_key) {
          window.history.replaceState(state, '', url);
        } else {
          window.history.pushState(state, '', url);
        }
      }
      this.pagination[mode] = {
        cursor: 0,
        batchSize: 20,
        loading: false,
        exhausted: false,
        error: null
      };
      (_this$mod$main4 = this.mod.main) === null || _this$mod$main4 === void 0 || (_this$mod$main4$showP = _this$mod$main4.showProfile) === null || _this$mod$main4$showP === void 0 || _this$mod$main4$showP.call(_this$mod$main4, this.active_profile_key);
      this.clearPrimaryNavigation();
      this.render();
      this.restoreScrollPosition(mode);
      this.syncFeedStatus();
    }
  }, {
    key: "isProfileViewMode",
    value: function isProfileViewMode() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.mode;
      return mode === 'posts' || mode === 'replies' || mode === 'likes';
    }
  }, {
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      this.ensureShell();
      this.updateModeVisibility();
      switch (this.mode) {
        case 'thread':
          this.paintThread();
          break;
        case 'notifications':
          this.paintNotifications();
          break;
        case 'posts':
        case 'replies':
        case 'likes':
          this.paintProfileView();
          break;
        case 'timeline':
        default:
          this.paintTimeline();
          break;
      }
      this.syncFeedHeader();
      this.attachEvents();
      this.syncScrollFooter();
      this.syncProfileNav();

      // Remounts (e.g. main.render → menu.render) restore Home as active by default;
      // re-clear so user-content views never leave primary nav highlighted.
      if (this.isProfileMode()) {
        this.clearPrimaryNavigation();
      }
    }
  }, {
    key: "ensureShell",
    value: function ensureShell() {
      var root = document.querySelector(this.container);
      if (root && root.querySelector('.body') && root.querySelector('.list[data-panel="timeline"]') && root.querySelector('.list[data-panel="profile"]')) {
        return;
      }
      this.app.browser.replaceElementContentBySelector(ManagerTemplate(), this.container);
      this.timeline_rendered = false;
      this.notifications_rendered = false;
      this.pagination = this.createPaginationState();
      this.pending_newer_tweets = [];
      this._timeline_bootstrapping = false;
      this._notifications_bootstrapping = false;
      this._last_scroll_top = 0;
    }
  }, {
    key: "updateModeVisibility",
    value: function updateModeVisibility() {
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      var timeline = root.querySelector('.list[data-panel="timeline"]');
      var thread = root.querySelector('.list[data-panel="thread"]');
      var notifications = root.querySelector('.list[data-panel="notifications"]');
      var profile = root.querySelector('.list[data-panel="profile"]');
      var profileModes = this.mode === 'posts' || this.mode === 'replies' || this.mode === 'likes';
      if (timeline) {
        timeline.hidden = this.mode !== 'timeline';
      }
      if (thread) {
        thread.hidden = this.mode !== 'thread';
      }
      if (notifications) {
        notifications.hidden = this.mode !== 'notifications';
      }
      if (profile) {
        profile.hidden = !profileModes;
      }
      if (this.mode !== 'timeline') {
        this.hideNewPostsBanner();
      } else if (this.pending_newer_tweets.length) {
        this.showNewPostsBanner();
      }
      this.syncFeedHeader();
    }

    /**
     * Feed-header chrome — mounted only when the active view needs navigation.
     * Creation lives in the sidebar Create component, not here.
     */
  }, {
    key: "syncFeedHeader",
    value: function syncFeedHeader() {
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      var showHeader = this.requiresHeader();
      var header = root.querySelector(':scope > .header');
      if (showHeader) {
        var _header, _header2;
        if (!header) {
          var body = root.querySelector(':scope > .body');
          if (body) {
            body.insertAdjacentHTML('beforebegin', ManagerHeaderTemplate());
          } else {
            root.insertAdjacentHTML('afterbegin', ManagerHeaderTemplate());
          }
          header = root.querySelector(':scope > .header');
        }
        var title = (_header = header) === null || _header === void 0 ? void 0 : _header.querySelector('.title');
        var back = (_header2 = header) === null || _header2 === void 0 ? void 0 : _header2.querySelector('.back');

        // Only views with viewChrome.header === true reach here (currently: thread).
        var labels = {
          timeline: 'Home',
          notifications: 'Notifications',
          thread: 'Tweet'
        };
        if (title) {
          title.textContent = labels[this.mode] || 'Home';
          title.hidden = false;
        }
        var isDetail = this.isDetailHeaderMode();
        var showBack = this.mode !== 'timeline';
        if (back) {
          back.hidden = !showBack;
          back.setAttribute('aria-hidden', showBack ? 'false' : 'true');
        }
        root.classList.toggle('has-back', showBack);
        root.classList.toggle('detail', isDetail);
        root.classList.toggle('timeline', !isDetail);
      } else if (header) {
        header.remove();
        root.classList.remove('has-back', 'detail');
        root.classList.add('timeline');
      }
      root.classList.toggle('has-header', showHeader);
    }

    /**
     * Whether the active view requires Manager header chrome (back + title).
     * Driven by `viewChrome.header` on all viewports.
     */
  }, {
    key: "requiresHeader",
    value: function requiresHeader() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.mode;
      var chrome = this.viewChrome[mode];
      if (chrome && typeof chrome.header === 'boolean') {
        return chrome.header;
      }

      // Unknown views keep the header (navigation/context by default).
      return true;
    }
  }, {
    key: "isCompactViewport",
    value: function isCompactViewport() {
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
        return false;
      }
      return window.matchMedia('(max-width: 600px)').matches;
    }

    /**
     * Detail views show Back; thread is the primary detail case.
     */
  }, {
    key: "isDetailHeaderMode",
    value: function isDetailHeaderMode() {
      return this.mode === 'thread';
    }
  }, {
    key: "syncProfileNav",
    value: function syncProfileNav() {
      var _this$mod$main5, _this$mod$main6;
      (_this$mod$main5 = this.mod.main) === null || _this$mod$main5 === void 0 || (_this$mod$main5 = _this$mod$main5.profile) === null || _this$mod$main5 === void 0 || _this$mod$main5.syncActiveNav(this.mode);
      (_this$mod$main6 = this.mod.main) === null || _this$mod$main6 === void 0 || (_this$mod$main6 = _this$mod$main6.mobile_profile) === null || _this$mod$main6 === void 0 || _this$mod$main6.syncActiveNav(this.mode);
    }
  }, {
    key: "navigateBackToTimeline",
    value: function navigateBackToTimeline() {
      var _window$history$state, _window$history$state2;
      if (typeof window !== 'undefined' && (((_window$history$state = window.history.state) === null || _window$history$state === void 0 ? void 0 : _window$history$state.redsquareView) === 'thread' || ((_window$history$state2 = window.history.state) === null || _window$history$state2 === void 0 ? void 0 : _window$history$state2.redsquareView) === 'profile')) {
        window.history.back();
        return;
      }
      this.replaceTweetLocation();
      this.renderTimeline({
        updateHistory: false
      });
    }
  }, {
    key: "replaceTweetLocation",
    value: function replaceTweetLocation() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$force = _ref4.force,
        force = _ref4$force === void 0 ? false : _ref4$force;
      if (typeof window === 'undefined' || !force && !this.mod.returnTweetSignatureFromLocation() && !this.mod.returnUserPublicKeyFromLocation()) {
        return;
      }
      window.history.replaceState({
        redsquareView: 'timeline'
      }, '', "/".concat(encodeURI(this.mod.returnSlug()), "/"));
    }
  }, {
    key: "attachBrowserHistory",
    value: function attachBrowserHistory() {
      var _this = this;
      if (typeof window === 'undefined' || this._browser_history_bound) {
        return;
      }
      this._browser_history_bound = true;
      window.addEventListener('popstate', function () {
        _this.applyLocationRoute();
      });
    }
  }, {
    key: "applyLocationRoute",
    value: function () {
      var _applyLocationRoute = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var _ref5,
          _ref5$refresh,
          refresh,
          signature,
          publicKey,
          _this$app$crypto,
          _window$history,
          canonicalPath,
          historyTab,
          requestedTab,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _ref5 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref5$refresh = _ref5.refresh, refresh = _ref5$refresh === void 0 ? false : _ref5$refresh;
              signature = this.mod.returnTweetSignatureFromLocation();
              publicKey = this.mod.returnUserPublicKeyFromLocation();
              if (!(publicKey && !signature)) {
                _context.n = 3;
                break;
              }
              this.clearPermalinkState();
              if (!((_this$app$crypto = this.app.crypto) !== null && _this$app$crypto !== void 0 && _this$app$crypto.isPublicKey && !this.app.crypto.isPublicKey(publicKey))) {
                _context.n = 1;
                break;
              }
              this.renderTimeline({
                updateHistory: false
              });
              return _context.a(2, null);
            case 1:
              canonicalPath = "/".concat(encodeURI(this.mod.returnSlug()), "/user/").concat(encodeURIComponent(publicKey));
              historyTab = typeof window !== 'undefined' ? (_window$history = window.history) === null || _window$history === void 0 || (_window$history = _window$history.state) === null || _window$history === void 0 ? void 0 : _window$history.tab : '';
              requestedTab = ['posts', 'replies', 'likes'].includes(historyTab) ? historyTab : this.isProfileMode() && this.active_profile_key === publicKey ? this.mode : 'posts';
              if (typeof window !== 'undefined' && window.location.pathname !== canonicalPath) {
                window.history.replaceState({
                  redsquareView: 'profile',
                  publicKey: publicKey,
                  tab: requestedTab
                }, '', this.mod.returnUserUrl(publicKey));
              }
              if (!(!refresh && this.isProfileMode() && this.active_profile_key === publicKey)) {
                _context.n = 2;
                break;
              }
              return _context.a(2, publicKey);
            case 2:
              this.renderProfileView(requestedTab, publicKey, {
                updateHistory: false
              });
              return _context.a(2, publicKey);
            case 3:
              if (signature) {
                _context.n = 4;
                break;
              }
              this.clearPermalinkState();
              if (this.mode === 'thread' || this.isProfileMode()) {
                this.renderTimeline({
                  updateHistory: false
                });
              }
              return _context.a(2, null);
            case 4:
              if (!(!refresh && this.mode === 'thread' && this.active_signature === signature)) {
                _context.n = 5;
                break;
              }
              return _context.a(2, this.mod.getTweet(signature));
            case 5:
              if (!(this._route_load && this._route_load_signature === signature)) {
                _context.n = 6;
                break;
              }
              if (refresh) {
                this._route_refresh_pending = true;
              }
              return _context.a(2, this._route_load);
            case 6:
              this.pending_route_signature = signature;
              this._route_load_signature = signature;
              if (!this.mod.getTweet(signature)) {
                this.renderPermalinkState(signature, 'loading');
              }
              this._route_load = this.mod.loadTweetThread(signature).then(function (result) {
                if (_this2.mod.returnTweetSignatureFromLocation() !== signature) {
                  return result;
                }
                if ((result === null || result === void 0 ? void 0 : result.status) === 'loaded' && result.tweet) {
                  _this2.pending_route_signature = '';
                  _this2.renderThread(signature, {
                    updateHistory: false
                  });
                } else {
                  var status = (result === null || result === void 0 ? void 0 : result.status) === 'unavailable' ? 'unavailable' : 'error';
                  _this2.renderPermalinkState(signature, status, result === null || result === void 0 ? void 0 : result.reason);
                }
                return result;
              })["catch"](function (err) {
                console.error('RedSquare shared tweet lookup failed:', err);
                if (_this2.mod.returnTweetSignatureFromLocation() === signature) {
                  _this2.renderPermalinkState(signature, 'error', 'lookup-failed');
                }
                return {
                  status: 'error',
                  reason: 'lookup-failed',
                  tweet: null
                };
              })["finally"](function () {
                if (_this2._route_load_signature === signature) {
                  var refreshPending = _this2._route_refresh_pending;
                  _this2._route_load_signature = '';
                  _this2._route_load = null;
                  _this2._route_refresh_pending = false;
                  if (refreshPending && _this2.mod.returnTweetSignatureFromLocation() === signature) {
                    setTimeout(function () {
                      if (!_this2._route_load && _this2.mod.returnTweetSignatureFromLocation() === signature) {
                        _this2.applyLocationRoute({
                          refresh: true
                        });
                      }
                    }, 0);
                  }
                }
              });
              return _context.a(2, this._route_load);
          }
        }, _callee, this);
      }));
      function applyLocationRoute() {
        return _applyLocationRoute.apply(this, arguments);
      }
      return applyLocationRoute;
    }()
  }, {
    key: "clearPermalinkState",
    value: function clearPermalinkState() {
      this.pending_route_signature = '';
      this.permalink_state = null;
      this._route_refresh_pending = false;
    }
  }, {
    key: "renderPermalinkState",
    value: function renderPermalinkState(signature, status) {
      var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      this.mode = 'thread';
      this.active_signature = signature || '';
      this.active_thread_id = '';
      this.active_profile_key = '';
      this.pending_route_signature = signature || '';
      this.permalink_state = {
        signature: signature,
        status: status,
        reason: reason
      };
      this.pagination.thread = _objectSpread(_objectSpread({}, this.createPaginationState().thread), {}, {
        loading: status === 'loading',
        exhausted: status !== 'loading',
        chain: []
      });
      this.render();
    }
  }, {
    key: "getScrollContainer",
    value: function getScrollContainer() {
      return document.querySelector("".concat(this.container, " .body")) || document.querySelector('.manager .body') || document.querySelector(this.container) || document.querySelector('#saito-container') || document.querySelector('.saito-container');
    }
  }, {
    key: "saveScrollPosition",
    value: function saveScrollPosition() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.mode;
      var scroller = this.getScrollContainer();
      if (!scroller || !mode || !this.scroll_positions) {
        return;
      }
      this.scroll_positions[mode] = scroller.scrollTop;
    }
  }, {
    key: "restoreScrollPosition",
    value: function restoreScrollPosition() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.mode;
      var scroller = this.getScrollContainer();
      if (!scroller || !mode || !this.scroll_positions) {
        return;
      }
      var scrollTop = this.scroll_positions[mode] || 0;
      requestAnimationFrame(function () {
        scroller.scrollTop = scrollTop;
      });
    }
  }, {
    key: "resetMenuToHome",
    value: function resetMenuToHome() {
      var _this$mod$main7;
      var homeItem = document.querySelector('.sidebar-left .menu [data-nav="home"]');
      if (homeItem && (_this$mod$main7 = this.mod.main) !== null && _this$mod$main7 !== void 0 && _this$mod$main7.menu) {
        this.mod.main.menu.setActiveMenuItem(homeItem);
      }
    }

    /**
     * User-content views are not primary navigation destinations.
     * Clear Home / Notifications / etc. selection while posts/replies/likes are shown.
     */
  }, {
    key: "clearPrimaryNavigation",
    value: function clearPrimaryNavigation() {
      var _this$mod$main8, _this$mod$main8$clear;
      (_this$mod$main8 = this.mod.main) === null || _this$mod$main8 === void 0 || (_this$mod$main8 = _this$mod$main8.menu) === null || _this$mod$main8 === void 0 || (_this$mod$main8$clear = _this$mod$main8.clearActiveMenuItem) === null || _this$mod$main8$clear === void 0 || _this$mod$main8$clear.call(_this$mod$main8);
    }
  }, {
    key: "getPaginationState",
    value: function getPaginationState() {
      return this.pagination[this.mode] || this.pagination.timeline;
    }
  }, {
    key: "getEndMessage",
    value: function getEndMessage() {
      return this.getFeedStatusMessage('end');
    }
  }, {
    key: "getFeedStatusMessage",
    value: function getFeedStatusMessage(status) {
      var _this$permalink_state, _messages$this$mode;
      if (this.mode === 'thread' && ((_this$permalink_state = this.permalink_state) === null || _this$permalink_state === void 0 ? void 0 : _this$permalink_state.status) === status) {
        if (status === 'unavailable' && this.permalink_state.reason === 'rejected') {
          return 'This tweet was found but could not be displayed.';
        }
        if (status === 'unavailable') {
          return 'This tweet is not available from your local archive or connected RedSquare peers.';
        }
        if (status === 'error') {
          return 'RedSquare could not check every available archive for this tweet.';
        }
      }
      var messages = {
        timeline: {
          loading: 'Loading tweets...',
          error: 'All peer tweets displayed.',
          empty: 'Peers have not returned any tweets',
          end: 'Peers have no more tweets.'
        },
        notifications: {
          loading: 'Loading notifications...',
          empty: "You're all caught up",
          end: 'Peers have no more notifications.'
        },
        thread: {
          loading: 'Loading replies...',
          empty: 'No replies.',
          end: 'Peers have no more replies.'
        },
        posts: {
          loading: 'Loading tweets...',
          error: 'All peer tweets displayed.',
          empty: 'Peers have not returned any tweets',
          end: 'Peers have no more tweets.'
        },
        replies: {
          loading: 'Loading replies...',
          error: 'All peer tweets displayed.',
          empty: 'No replies.',
          end: 'Peers have no more replies.'
        },
        likes: {
          loading: 'Loading likes...',
          error: 'All peer tweets displayed.',
          empty: 'No liked tweets.',
          end: 'Peers have no more liked tweets.'
        }
      };
      return ((_messages$this$mode = messages[this.mode]) === null || _messages$this$mode === void 0 ? void 0 : _messages$this$mode[status]) || '';
    }
  }, {
    key: "isProfileMode",
    value: function isProfileMode() {
      return this.mode === 'posts' || this.mode === 'replies' || this.mode === 'likes';
    }
  }, {
    key: "getActivePanelElement",
    value: function getActivePanelElement() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.mode;
      var root = document.querySelector(this.container);
      if (!root) {
        return null;
      }
      switch (mode) {
        case 'thread':
          return root.querySelector('.list[data-panel="thread"]');
        case 'notifications':
          return root.querySelector('.list[data-panel="notifications"]');
        case 'posts':
        case 'replies':
        case 'likes':
          return root.querySelector('.list[data-panel="profile"]');
        case 'timeline':
        default:
          return root.querySelector('.list[data-panel="timeline"]');
      }
    }
  }, {
    key: "getActivePanelSelector",
    value: function getActivePanelSelector() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.mode;
      switch (mode) {
        case 'thread':
          return "".concat(this.container, " .list[data-panel=\"thread\"]");
        case 'notifications':
          return "".concat(this.container, " .list[data-panel=\"notifications\"]");
        case 'posts':
        case 'replies':
        case 'likes':
          return "".concat(this.container, " .list[data-panel=\"profile\"]");
        case 'timeline':
        default:
          return "".concat(this.container, " .list[data-panel=\"timeline\"]");
      }
    }
  }, {
    key: "clearPanel",
    value: function clearPanel(selector) {
      var panel = document.querySelector(selector);
      if (panel) {
        panel.innerHTML = '';
      }
    }
  }, {
    key: "paintTimeline",
    value: function paintTimeline() {
      if (this._timeline_bootstrapping) {
        this.syncFeedStatus();
        return;
      }
      if (this.timeline_rendered) {
        // Home may have completed an empty local load before a permalink's
        // remote peer arrived. Its first remote page is still needed on return.
        var needsRemoteBootstrap = !this.pagination.timeline.error && this.getRenderedTimelineSignatures().size === 0 && (this.mod.peers || []).some(function (source) {
          return source.peer !== 'localhost' && !source.tweets_hydrated;
        });
        if (!needsRemoteBootstrap) {
          // Thread/profile lookups can have populated the cache while away.
          this.fillTimelineToViewport();
          this.syncFeedStatus();
          return;
        }
        this.timeline_rendered = false;
      }
      this.bootstrapTimeline();
    }
  }, {
    key: "bootstrapTimeline",
    value: function () {
      var _bootstrapTimeline = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var state, result, unhydratedRemote, followup;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(this.timeline_rendered || this._timeline_bootstrapping)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              this._timeline_bootstrapping = true;
              state = this.pagination.timeline;
              this.syncFeedStatus();
              _context2.n = 2;
              return this.requestTweetLoad('newer');
            case 2:
              result = _context2.v;
              if (!(this.pagination.timeline !== state)) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              this.mod.resortTimeline();
              this.clearPanel(this.getActivePanelSelector('timeline'));
              this.pagination.timeline.exhausted = false;
              this.pagination.timeline.error = result.failed ? {
                direction: 'newer'
              } : null;
              // A coalesced poll can queue this same page before bootstrap resumes.
              // All cached roots belong to the initial render, including those queued.
              this.pending_newer_tweets = [];
              this.hideNewPostsBanner();
              this.fillTimelineToViewport();
              this.timeline_rendered = true;
              this._timeline_bootstrapping = false;
              this.syncFeedStatus();
              if (!result.failed) {
                _context2.n = 4;
                break;
              }
              this.resumePeerHistory();
              return _context2.a(2);
            case 4:
              unhydratedRemote = (this.mod.peers || []).some(function (peer_obj) {
                return peer_obj.peer !== 'localhost' && !peer_obj.tweets_hydrated;
              });
              if (!unhydratedRemote) {
                _context2.n = 9;
                break;
              }
              this._peer_timeline_refreshes++;
              _context2.p = 5;
              _context2.n = 6;
              return this.requestTweetLoad('newer');
            case 6:
              followup = _context2.v;
              if (!(this.pagination.timeline !== state)) {
                _context2.n = 7;
                break;
              }
              return _context2.a(2);
            case 7:
              this.onNewerContentLoaded(followup, {
                announce: !this.isNearTop()
              });
            case 8:
              _context2.p = 8;
              this._peer_timeline_refreshes--;
              return _context2.f(8);
            case 9:
              this.resumePeerHistory();
              if (this.mode === 'timeline' && this.isNearBottom()) {
                this.loadMoreIfNeeded();
              }
            case 10:
              return _context2.a(2);
          }
        }, _callee2, this, [[5,, 8, 9]]);
      }));
      function bootstrapTimeline() {
        return _bootstrapTimeline.apply(this, arguments);
      }
      return bootstrapTimeline;
    }()
  }, {
    key: "paintThread",
    value: function paintThread() {
      var container = "".concat(this.container, " .list[data-panel=\"thread\"]");
      this.clearPanel(container);
      this.renderThreadContextLink(container);
      this.appendThreadBatch();
      this.syncFeedStatus();
    }
  }, {
    key: "renderThreadContextLink",
    value: function renderThreadContextLink(container) {
      var focused = this.mod.getTweet(this.active_signature);
      if (!(focused !== null && focused !== void 0 && focused.parent_id)) {
        return;
      }
      var root = this.getThreadRoot(this.active_signature);
      var html = "\n      <div class=\"thread-context\" role=\"button\" tabindex=\"0\" data-root=\"".concat(root, "\">\n        View entire thread\n      </div>\n    ");
      this.app.browser.addElementToSelector(html, container);
    }
  }, {
    key: "paintNotifications",
    value: function paintNotifications() {
      if (this.notifications_rendered || this._notifications_bootstrapping) {
        this.renderModerateQueue();
        this.syncFeedStatus();
        return;
      }
      this.bootstrapNotifications();
    }
  }, {
    key: "renderModerateQueue",
    value: function renderModerateQueue() {
      if (!this.mod.moderator_mode || !this.mod.moderate) {
        return;
      }
      this.mod.moderate.render(this.getActivePanelSelector());
    }
  }, {
    key: "bootstrapNotifications",
    value: function () {
      var _bootstrapNotifications = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var state;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(this.notifications_rendered || this._notifications_bootstrapping)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              this._notifications_bootstrapping = true;
              state = this.pagination.notifications;
              this.syncFeedStatus();
              this.renderModerateQueue();
              this.appendNotificationsBatch();
              _context3.n = 2;
              return this.loadNotificationDirection('newer');
            case 2:
              if (!(this.pagination.notifications !== state)) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              if (!(this.getRenderedItemCount('notifications') === 0)) {
                _context3.n = 4;
                break;
              }
              _context3.n = 4;
              return this.loadNotificationDirection('older');
            case 4:
              if (!(this.pagination.notifications !== state)) {
                _context3.n = 5;
                break;
              }
              return _context3.a(2);
            case 5:
              this.notifications_rendered = true;
              this._notifications_bootstrapping = false;
              if (this.getRenderedItemCount('notifications') === 0) {
                state.loading = false;
                state.exhausted = true;
              }
              this.syncFeedStatus();
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function bootstrapNotifications() {
        return _bootstrapNotifications.apply(this, arguments);
      }
      return bootstrapNotifications;
    }()
  }, {
    key: "loadNotificationDirection",
    value: function loadNotificationDirection(direction) {
      var _this3 = this;
      var state = this.pagination.notifications;
      return new Promise(function (resolve) {
        var settled = false;
        var finish = function finish(result) {
          if (settled) {
            return;
          }
          settled = true;
          if (_this3.pagination.notifications !== state) {
            resolve();
            return;
          }
          if (direction === 'newer') {
            _this3.handleNewerNotifications(result || {
              type: 'notifications',
              direction: 'newer',
              added: [],
              updated: [],
              ignored: [],
              exhausted: true
            });
          } else {
            _this3.applyOlderLoadResult(result || {
              type: 'notifications',
              direction: 'older',
              added: [],
              updated: [],
              ignored: [],
              exhausted: true
            }, 'notifications');
          }
          resolve();
        };
        var timer = setTimeout(function () {
          finish({
            type: 'notifications',
            direction: direction,
            added: [],
            updated: [],
            ignored: [],
            exhausted: true
          });
        }, 12000);
        try {
          _this3.mod.loadTransactions('notifications', direction, function (result) {
            clearTimeout(timer);
            finish(result);
          });
        } catch (err) {
          clearTimeout(timer);
          finish({
            type: 'notifications',
            direction: direction,
            added: [],
            updated: [],
            ignored: [],
            exhausted: true
          });
        }
      });
    }
  }, {
    key: "paintProfileView",
    value: function paintProfileView() {
      var container = this.getActivePanelSelector();
      this.clearPanel(container);
      if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 820px)').matches) {
        var _this$mod$main9, _this$mod$main9$showM;
        this.app.browser.addElementToSelector('<section class="redsquare-profile mobile"></section>', container);
        (_this$mod$main9 = this.mod.main) === null || _this$mod$main9 === void 0 || (_this$mod$main9$showM = _this$mod$main9.showMobileProfile) === null || _this$mod$main9$showM === void 0 || _this$mod$main9$showM.call(_this$mod$main9, this.active_profile_key);
      }
      this.appendProfileBatch();
      var state = this.getPaginationState();
      var source = this.getActiveProfileSource();
      state.error = source.error;
      state.exhausted = Boolean((source === null || source === void 0 ? void 0 : source.exhausted) && state.cursor >= this.collectProfileTweets().length);
      this.syncFeedStatus();
      if (!state.exhausted && this.isNearBottom()) {
        this.loadMore();
      }
    }
  }, {
    key: "createProfileSourceState",
    value: function createProfileSourceState() {
      return {
        loading: false,
        exhausted: false,
        error: null,
        peers: {}
      };
    }
  }, {
    key: "getProfileCache",
    value: function getProfileCache() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active_profile_key;
      var key = publicKey || '';
      if (!this.profile_cache[key]) {
        var cache = {
          posts: [],
          replies: [],
          likes: [],
          postSet: new Set(),
          replySet: new Set(),
          likeSet: new Set(),
          author: this.createProfileSourceState(),
          likesSource: this.createProfileSourceState()
        };
        for (var _i = 0, _Object$values = Object.values(this.mod.tweets || {}); _i < _Object$values.length; _i++) {
          var tweet = _Object$values[_i];
          if ((tweet === null || tweet === void 0 ? void 0 : tweet.publicKey) === key) {
            this.addTweetToProfileCache(cache, tweet, tweet.parent_id ? 'replies' : 'posts');
          }
          if (Array.isArray(tweet === null || tweet === void 0 ? void 0 : tweet.likers) && tweet.likers.includes(key)) {
            this.addTweetToProfileCache(cache, tweet, 'likes');
          }
        }
        this.profile_cache[key] = cache;
      }
      return this.profile_cache[key];
    }
  }, {
    key: "addTweetToProfileCache",
    value: function addTweetToProfileCache(cache, tweet, mode) {
      var _this4 = this;
      var signature = (tweet === null || tweet === void 0 ? void 0 : tweet.signature) || '';
      var setName = mode === 'posts' ? 'postSet' : mode === 'replies' ? 'replySet' : 'likeSet';
      if (!signature || cache[setName].has(signature)) {
        return false;
      }
      cache[setName].add(signature);
      cache[mode].push(signature);
      cache[mode].sort(function (a, b) {
        var first = _this4.mod.getTweet(a);
        var second = _this4.mod.getTweet(b);
        return (Number(second === null || second === void 0 ? void 0 : second.created_at) || 0) - (Number(first === null || first === void 0 ? void 0 : first.created_at) || 0);
      });
      return true;
    }
  }, {
    key: "getActiveProfileSource",
    value: function getActiveProfileSource() {
      var cache = this.getProfileCache();
      return this.mode === 'likes' ? cache.likesSource : cache.author;
    }
  }, {
    key: "returnProfilePeerKey",
    value: function returnProfilePeerKey(peer, index) {
      if (peer === 'localhost') {
        return 'localhost';
      }
      return (peer === null || peer === void 0 ? void 0 : peer.publicKey) || "peer-".concat(index);
    }
  }, {
    key: "loadProfileArchivePage",
    value: function () {
      var _loadProfileArchivePage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this$app$modules,
          _this$app$modules$mod,
          _this5 = this;
        var publicKey, mode, cache, source, limit, peers, failed, likedLookups, counts;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              publicKey = this.active_profile_key || '';
              mode = this.mode;
              cache = this.getProfileCache(publicKey);
              source = mode === 'likes' ? cache.likesSource : cache.author;
              if (!(!publicKey || source.loading || source.exhausted)) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2, 0);
            case 1:
              if (!(((_this$app$modules = this.app.modules) === null || _this$app$modules === void 0 || (_this$app$modules$mod = _this$app$modules.moderateAddress) === null || _this$app$modules$mod === void 0 ? void 0 : _this$app$modules$mod.call(_this$app$modules, publicKey)) === -1)) {
                _context6.n = 2;
                break;
              }
              source.exhausted = true;
              return _context6.a(2, 0);
            case 2:
              source.loading = true;
              limit = 20;
              peers = this.mod.returnTweetArchivePeers();
              failed = false;
              likedLookups = new Map();
              _context6.p = 3;
              _context6.n = 4;
              return Promise.all(peers.map(/*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(peer, index) {
                  var peerKey, peerState, query, result, txs, tweetTransactions, targetsFailed, signatures, _iterator, _step, _this5$app$modules, _this5$app$modules$mo, _tx$returnMessage, _message$data, tx, message, signature, targets, tweets, added, _iterator2, _step2, tweet, targetMode, timestamps, _t, _t2, _t3;
                  return _regenerator().w(function (_context5) {
                    while (1) switch (_context5.p = _context5.n) {
                      case 0:
                        peerKey = _this5.returnProfilePeerKey(peer, index);
                        peerState = source.peers[peerKey] || {
                          cursor: Date.now() + 1,
                          exhausted: false
                        };
                        source.peers[peerKey] = peerState;
                        if (!peerState.exhausted) {
                          _context5.n = 1;
                          break;
                        }
                        return _context5.a(2, 0);
                      case 1:
                        _context5.p = 1;
                        query = {
                          field1: mode === 'likes' ? 'RedSquareLike' : 'RedSquare',
                          field2: publicKey,
                          created_earlier_than: peerState.cursor,
                          limit: limit
                        };
                        if (mode !== 'likes') {
                          query.flagged_ne = 1;
                        }
                        _context5.n = 2;
                        return _this5.mod.loadArchiveTransactionsWithStatus(query, peer);
                      case 2:
                        result = _context5.v;
                        if (!(result.status !== 'loaded')) {
                          _context5.n = 3;
                          break;
                        }
                        failed = true;
                        return _context5.a(2, 0);
                      case 3:
                        txs = result.transactions;
                        tweetTransactions = txs;
                        targetsFailed = false;
                        if (!(mode === 'likes')) {
                          _context5.n = 14;
                          break;
                        }
                        signatures = new Set();
                        _iterator = _createForOfIteratorHelper(txs);
                        _context5.p = 4;
                        _iterator.s();
                      case 5:
                        if ((_step = _iterator.n()).done) {
                          _context5.n = 9;
                          break;
                        }
                        tx = _step.value;
                        if (!(typeof (tx === null || tx === void 0 ? void 0 : tx.decryptMessage) === 'function')) {
                          _context5.n = 6;
                          break;
                        }
                        _context5.n = 6;
                        return tx.decryptMessage(_this5.app);
                      case 6:
                        if (!(((_this5$app$modules = _this5.app.modules) === null || _this5$app$modules === void 0 || (_this5$app$modules$mo = _this5$app$modules.moderate) === null || _this5$app$modules$mo === void 0 ? void 0 : _this5$app$modules$mo.call(_this5$app$modules, tx, _this5.mod.name)) === -1)) {
                          _context5.n = 7;
                          break;
                        }
                        return _context5.a(3, 8);
                      case 7:
                        message = (tx === null || tx === void 0 || (_tx$returnMessage = tx.returnMessage) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.call(tx)) || (tx === null || tx === void 0 ? void 0 : tx.msg) || {};
                        signature = (_message$data = message.data) === null || _message$data === void 0 ? void 0 : _message$data.signature;
                        if (signature != null && String(signature)) {
                          signatures.add(String(signature));
                        }
                      case 8:
                        _context5.n = 5;
                        break;
                      case 9:
                        _context5.n = 11;
                        break;
                      case 10:
                        _context5.p = 10;
                        _t = _context5.v;
                        _iterator.e(_t);
                      case 11:
                        _context5.p = 11;
                        _iterator.f();
                        return _context5.f(11);
                      case 12:
                        _context5.n = 13;
                        return Promise.all(Array.from(signatures, /*#__PURE__*/function () {
                          var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(signature) {
                            var results, transactions, found;
                            return _regenerator().w(function (_context4) {
                              while (1) switch (_context4.n) {
                                case 0:
                                  if (!likedLookups.has(signature)) {
                                    likedLookups.set(signature, Promise.all(peers.map(function (targetPeer) {
                                      return _this5.mod.loadArchiveTransactionsWithStatus({
                                        sig: signature,
                                        field1: 'RedSquare',
                                        flagged_ne: 1
                                      }, targetPeer);
                                    })));
                                  }
                                  _context4.n = 1;
                                  return likedLookups.get(signature);
                                case 1:
                                  results = _context4.v;
                                  transactions = results.flatMap(function (entry) {
                                    return entry.status === 'loaded' ? entry.transactions : [];
                                  });
                                  found = transactions.some(function (tx) {
                                    return String((tx === null || tx === void 0 ? void 0 : tx.signature) || '') === signature;
                                  });
                                  if (!found && results.some(function (entry) {
                                    return entry.status !== 'loaded';
                                  })) {
                                    targetsFailed = true;
                                  }
                                  return _context4.a(2, transactions);
                              }
                            }, _callee4);
                          }));
                          return function (_x3) {
                            return _ref7.apply(this, arguments);
                          };
                        }()));
                      case 13:
                        targets = _context5.v;
                        tweetTransactions = targets.flat();
                      case 14:
                        _context5.n = 15;
                        return _this5.mod.cacheProfileTweetTransactions(tweetTransactions);
                      case 15:
                        tweets = _context5.v;
                        added = 0;
                        _iterator2 = _createForOfIteratorHelper(tweets);
                        _context5.p = 16;
                        _iterator2.s();
                      case 17:
                        if ((_step2 = _iterator2.n()).done) {
                          _context5.n = 20;
                          break;
                        }
                        tweet = _step2.value;
                        if (!(mode !== 'likes' && tweet.publicKey !== publicKey)) {
                          _context5.n = 18;
                          break;
                        }
                        return _context5.a(3, 19);
                      case 18:
                        targetMode = mode === 'likes' ? 'likes' : tweet.parent_id ? 'replies' : 'posts';
                        if (_this5.addTweetToProfileCache(cache, tweet, targetMode)) {
                          added++;
                        }
                      case 19:
                        _context5.n = 17;
                        break;
                      case 20:
                        _context5.n = 22;
                        break;
                      case 21:
                        _context5.p = 21;
                        _t2 = _context5.v;
                        _iterator2.e(_t2);
                      case 22:
                        _context5.p = 22;
                        _iterator2.f();
                        return _context5.f(22);
                      case 23:
                        if (!targetsFailed) {
                          _context5.n = 24;
                          break;
                        }
                        // Keep this likes page available for retrying its missing targets.
                        failed = true;
                        return _context5.a(2, added);
                      case 24:
                        timestamps = txs.map(function (tx) {
                          return Number(tx === null || tx === void 0 ? void 0 : tx.timestamp) || 0;
                        }).filter(Boolean);
                        if (timestamps.length) {
                          peerState.cursor = Math.min.apply(Math, _toConsumableArray(timestamps));
                        }
                        peerState.exhausted = txs.length < limit;
                        return _context5.a(2, added);
                      case 25:
                        _context5.p = 25;
                        _t3 = _context5.v;
                        failed = true;
                        return _context5.a(2, 0);
                    }
                  }, _callee5, null, [[16, 21, 22, 23], [4, 10, 11, 12], [1, 25]]);
                }));
                return function (_x, _x2) {
                  return _ref6.apply(this, arguments);
                };
              }()));
            case 4:
              counts = _context6.v;
              source.error = failed ? {
                direction: 'older'
              } : null;
              source.exhausted = !failed && Object.values(source.peers).every(function (peerState) {
                return peerState.exhausted;
              });
              return _context6.a(2, counts.reduce(function (total, count) {
                return total + count;
              }, 0));
            case 5:
              _context6.p = 5;
              source.loading = false;
              return _context6.f(5);
            case 6:
              return _context6.a(2);
          }
        }, _callee6, this, [[3,, 5, 6]]);
      }));
      function loadProfileArchivePage() {
        return _loadProfileArchivePage.apply(this, arguments);
      }
      return loadProfileArchivePage;
    }()
  }, {
    key: "appendProfileBatch",
    value: function appendProfileBatch() {
      var state = this.getPaginationState();
      var tweets = this.collectProfileTweets();
      var batch = tweets.slice(state.cursor, state.cursor + state.batchSize);
      var container = this.getActivePanelSelector();
      var _iterator3 = _createForOfIteratorHelper(batch),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var tweet = _step3.value;
          tweet.render(container);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      state.cursor += batch.length;
      this.syncFeedStatus();
      return batch.length;
    }
  }, {
    key: "collectProfileTweets",
    value: function collectProfileTweets() {
      var _this$app$modules2,
        _this$app$modules2$mo,
        _this6 = this;
      if (((_this$app$modules2 = this.app.modules) === null || _this$app$modules2 === void 0 || (_this$app$modules2$mo = _this$app$modules2.moderateAddress) === null || _this$app$modules2$mo === void 0 ? void 0 : _this$app$modules2$mo.call(_this$app$modules2, this.active_profile_key)) === -1) {
        return [];
      }
      var cache = this.getProfileCache();
      return (cache[this.mode] || []).map(function (signature) {
        return _this6.mod.getTweet(signature);
      }).filter(Boolean);
    }
  }, {
    key: "getUnrenderedTimelineSignatures",
    value: function getUnrenderedTimelineSignatures() {
      var _this7 = this;
      var rendered = this.getRenderedTimelineSignatures();
      var pending = new Set(this.pending_newer_tweets);
      return (this.mod.tweets_timeline || []).filter(function (signature) {
        var tweet = _this7.mod.getTweet(signature);
        return tweet && !tweet.parent_id && !tweet.ephemeral && !rendered.has(signature) && !pending.has(signature);
      });
    }
  }, {
    key: "appendTimelineBatch",
    value: function appendTimelineBatch() {
      var state = this.pagination.timeline;
      var signatures = this.getUnrenderedTimelineSignatures().slice(0, state.batchSize);
      var container = this.getActivePanelSelector('timeline');
      if (signatures.length === 0) {
        this.syncFeedStatus();
        return 0;
      }
      var panel = document.querySelector(container);
      if (!panel) {
        return 0;
      }
      var _iterator4 = _createForOfIteratorHelper(signatures),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var signature = _step4.value;
          var tweet = this.mod.getTweet(signature);
          if (tweet && !(panel !== null && panel !== void 0 && panel.querySelector("article.tweet[data-id=\"".concat(signature, "\"]")))) {
            this.renderTweetWithCriticalChild(tweet, container);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      var rendered = this.getRenderedTimelineSignatures();
      this.syncFeedStatus();
      this.observeVisibleTweets();
      return signatures.filter(function (signature) {
        return rendered.has(signature);
      }).length;
    }
  }, {
    key: "fillTimelineToViewport",
    value: function fillTimelineToViewport() {
      var painted = 0;
      var batch;
      do {
        batch = this.appendTimelineBatch();
        painted += batch;
      } while (batch > 0 && this.mode === 'timeline' && this.isNearBottom());
      return painted;
    }
  }, {
    key: "oldestRenderedTweetTs",
    value: function oldestRenderedTweetTs() {
      var oldest = 0;
      var _iterator5 = _createForOfIteratorHelper(this.getRenderedTimelineSignatures()),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var signature = _step5.value;
          var tweet = this.mod.getTweet(signature);
          var timestamp = Number(tweet === null || tweet === void 0 ? void 0 : tweet.created_at) || 0;
          if (tweet && !tweet.parent_id && !tweet.ephemeral && timestamp > 0 && (!oldest || timestamp < oldest)) {
            oldest = timestamp;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return oldest || Date.now();
    }
  }, {
    key: "appendNotificationsBatch",
    value: function appendNotificationsBatch() {
      var state = this.pagination.notifications;
      var signatures = this.mod.notifications_timeline.slice(state.cursor, state.cursor + state.batchSize);
      var container = this.getActivePanelSelector('notifications');
      if (signatures.length === 0) {
        this.syncFeedStatus();
        return 0;
      }
      var _iterator6 = _createForOfIteratorHelper(signatures),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var signature = _step6.value;
          var notification = this.mod.getNotification(signature);
          if (notification) {
            notification.render(container);
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      state.cursor += signatures.length;
      this.syncFeedStatus();
      return signatures.length;
    }
  }, {
    key: "appendThreadBatch",
    value: function appendThreadBatch() {
      var state = this.pagination.thread;
      var signatures = state.chain.slice(state.cursor, state.cursor + state.batchSize);
      var container = this.getActivePanelSelector();
      if (signatures.length === 0) {
        if (state.cursor >= state.chain.length) {
          state.exhausted = true;
        }
        this.syncFeedStatus();
        return 0;
      }
      for (var i = 0; i < signatures.length; i++) {
        var signature = signatures[i];
        var tweet = this.mod.getTweet(signature);
        var globalIndex = state.cursor + i;
        if (!tweet) {
          continue;
        }
        var options = this.buildThreadRenderOptions(globalIndex, state.chain);
        tweet.render(container, options);
      }
      state.cursor += signatures.length;
      if (state.cursor >= state.chain.length) {
        state.exhausted = true;
      }
      this.syncFeedStatus();
      return signatures.length;
    }
  }, {
    key: "buildThreadRenderOptions",
    value: function buildThreadRenderOptions(globalIndex) {
      var chain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var signatures = Array.isArray(chain) ? chain : [];
      var signature = signatures[globalIndex] || '';
      var tweet = signature ? this.mod.getTweet(signature) : null;
      var previousSignature = globalIndex > 0 ? signatures[globalIndex - 1] : '';
      var nextSignature = globalIndex < signatures.length - 1 ? signatures[globalIndex + 1] : '';
      var next = nextSignature ? this.mod.getTweet(nextSignature) : null;
      var options = {};
      var rootSignature = signatures[0] || '';
      if (globalIndex === 0) {
        options.focused = true;
        options.presentation = 'focused';
        return options;
      }
      options.reply = true;
      options.presentation = 'reply';

      // The focused tweet is the page root. Its direct replies are separate
      // responses, so they do not inherit a connector. A line is only for a
      // reply that answers another reply.
      var previous = previousSignature ? this.mod.getTweet(previousSignature) : null;
      var nestedParent = function nestedParent(parentSignature) {
        return Boolean(parentSignature) && parentSignature !== rootSignature;
      };
      var continuesParent = nestedParent(tweet === null || tweet === void 0 ? void 0 : tweet.parent_id) && tweet.parent_id === previousSignature;
      var continuesSibling = nestedParent(tweet === null || tweet === void 0 ? void 0 : tweet.parent_id) && (previous === null || previous === void 0 ? void 0 : previous.parent_id) === tweet.parent_id;
      if (continuesParent || continuesSibling) {
        options.chainPrev = true;
      }
      var nextIsChild = nestedParent(signature) && (next === null || next === void 0 ? void 0 : next.parent_id) === signature;
      var nextIsSibling = nestedParent(tweet === null || tweet === void 0 ? void 0 : tweet.parent_id) && (next === null || next === void 0 ? void 0 : next.parent_id) === tweet.parent_id;
      if (nextIsChild || nextIsSibling) {
        options.chainNext = true;
        options.chainContinue = true;
      }
      return options;
    }
  }, {
    key: "appendLoadedItems",
    value: function appendLoadedItems(result) {
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.mode;
      var container = this.getActivePanelSelector(mode);
      var state = this.pagination[mode];
      var signatures = result.added || [];
      if (mode === 'notifications') {
        var _iterator7 = _createForOfIteratorHelper(signatures),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var signature = _step7.value;
            var notification = this.mod.getNotification(signature);
            if (notification) {
              notification.render(container);
            }
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
        state.cursor += signatures.length;
        return;
      }
      if (mode === 'thread') {
        var startIndex = state.cursor;
        for (var i = 0; i < signatures.length; i++) {
          var _signature = signatures[i];
          var tweet = this.mod.getTweet(_signature);
          var globalIndex = startIndex + i;
          if (!tweet) {
            continue;
          }
          tweet.render(container, this.buildThreadRenderOptions(globalIndex, state.chain));
        }
        state.cursor += signatures.length;
      }
    }
  }, {
    key: "resetThreadPagination",
    value: function resetThreadPagination(signature) {
      var chain = this.buildThreadView(signature);
      this.pagination.thread = _objectSpread(_objectSpread({}, this.createPaginationState().thread), {}, {
        batchSize: Math.max(this.createPaginationState().thread.batchSize, chain.length),
        chain: chain
      });
    }
  }, {
    key: "buildThreadView",
    value: function buildThreadView(signature) {
      var _this8 = this;
      if (!signature) {
        return [];
      }
      var chain = [];
      var visited = new Set();
      var _visit = function visit(currentSignature) {
        if (visited.has(currentSignature)) {
          return;
        }
        visited.add(currentSignature);
        if (!_this8.mod.getTweet(currentSignature)) {
          return;
        }
        chain.push(currentSignature);
        var _iterator8 = _createForOfIteratorHelper(_this8.getDirectReplies(currentSignature)),
          _step8;
        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var childSignature = _step8.value;
            _visit(childSignature);
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      };
      _visit(signature);
      return chain;
    }
  }, {
    key: "getDirectReplies",
    value: function getDirectReplies(parentSignature) {
      var _this$mod$tweets_chil,
        _this9 = this;
      var children = new Set(((_this$mod$tweets_chil = this.mod.tweets_children) === null || _this$mod$tweets_chil === void 0 ? void 0 : _this$mod$tweets_chil[parentSignature]) || []);

      // Reconstruct missing index entries from the tweets themselves. Archive
      // batches can arrive in any order, but a loaded reply must never disappear
      // when switching from a focused reply to the complete thread.
      for (var _i2 = 0, _Object$values2 = Object.values(this.mod.tweets || {}); _i2 < _Object$values2.length; _i2++) {
        var tweet = _Object$values2[_i2];
        if ((tweet === null || tweet === void 0 ? void 0 : tweet.parent_id) === parentSignature && tweet.signature) {
          children.add(tweet.signature);
        }
      }
      return _toConsumableArray(children).map(function (sig) {
        return _this9.mod.getTweet(sig);
      }).filter(Boolean).sort(function (a, b) {
        var timestampDifference = (a.created_at || 0) - (b.created_at || 0);
        return timestampDifference || a.signature.localeCompare(b.signature);
      }).map(function (tweet) {
        return tweet.signature;
      });
    }
  }, {
    key: "getThreadRoot",
    value: function getThreadRoot(signature) {
      var root = signature;
      var visited = new Set([root]);
      while ((_this$mod$tweets_pare = this.mod.tweets_parents) !== null && _this$mod$tweets_pare !== void 0 && _this$mod$tweets_pare[root]) {
        var _this$mod$tweets_pare;
        var parent = this.mod.tweets_parents[root];
        if (visited.has(parent) || !this.mod.getTweet(parent)) {
          break;
        }
        visited.add(parent);
        root = parent;
      }
      if (root !== signature) {
        return root;
      }
      var tweet = this.mod.getTweet(signature);
      if (tweet !== null && tweet !== void 0 && tweet.thread_id && tweet.thread_id !== tweet.signature) {
        return tweet.thread_id;
      }
      return (tweet === null || tweet === void 0 ? void 0 : tweet.parent_id) || root;
    }

    //
    // Compose integration — Manager owns all post-submit rendering
    //
  }, {
    key: "onTweetPosted",
    value: function onTweetPosted(tweet) {
      if (!tweet) {
        return;
      }
      var isReply = Boolean(tweet.parent_id);
      if (this.mode === 'thread' && isReply && tweet.parent_id === this.active_signature) {
        this.insertThreadReply(tweet);
        return;
      }
      if (this.mode !== 'timeline') {
        if (isReply) {
          this.openThreadForPostedReply(tweet);
          return;
        }
        this.renderTimelineForNewPost();
      }
      if (!isReply) {
        this.insertTimelineTweet(tweet);
      }
    }
  }, {
    key: "onTweetDeleted",
    value: function onTweetDeleted(signature) {
      if (!signature) {
        return;
      }
      document.querySelectorAll("article.tweet[data-id=\"".concat(signature, "\"]")).forEach(function (el) {
        return el.remove();
      });
      if (this.mode === 'thread' && this.active_signature === signature) {
        this.renderTimelineForNewPost();
      }
    }
  }, {
    key: "renderTimelineForNewPost",
    value: function renderTimelineForNewPost() {
      var _this0 = this;
      this.saveScrollPosition();
      this.mode = 'timeline';
      this.active_signature = '';
      this.active_thread_id = '';
      this.active_profile_key = '';
      this.replaceTweetLocation();
      this.scroll_positions.timeline = 0;
      this.updateModeVisibility();
      this.syncFeedHeader();
      this.resetMenuToHome();
      this.syncProfileNav();
      if (!this.timeline_rendered) {
        this.paintTimeline();
      }
      this.syncScrollFooter();
      requestAnimationFrame(function () {
        var scroller = _this0.getScrollContainer();
        if (scroller) {
          scroller.scrollTop = 0;
        }
      });
    }
  }, {
    key: "openThreadForPostedReply",
    value: function openThreadForPostedReply(tweet) {
      if (!tweet) {
        return;
      }
      this.openEntireThread(tweet.signature);
    }
  }, {
    key: "insertTimelineTweet",
    value: function insertTimelineTweet(tweet) {
      if (!tweet || tweet.parent_id) {
        return;
      }
      var container = "".concat(this.container, " .list[data-panel=\"timeline\"]");
      var panel = document.querySelector(container);
      if (!panel) {
        return;
      }
      var child = tweet.critical_child ? this.mod.getTweet(tweet.critical_child) : null;
      var options = {};
      if (child) {
        options.chainNext = true;
        options.chainContinue = true;
        options.presentation = 'root';
        options.root = true;
      }
      var html = TweetTemplate(tweet, tweet.buildClassName(options), options);
      this.app.browser.prependElementToSelector(html, container);
      this.timeline_rendered = true;
      if (child) {
        var childOptions = {
          chainPrev: true,
          presentation: 'reply',
          reply: true
        };
        var childHtml = TweetTemplate(child, child.buildClassName(childOptions), childOptions);
        var parentEl = panel.querySelector("article.tweet[data-id=\"".concat(tweet.signature, "\"]"));
        if (parentEl) {
          parentEl.insertAdjacentHTML('afterend', childHtml);
        }
      }
      var element = panel.querySelector("article.tweet[data-id=\"".concat(tweet.signature, "\"]"));
      this.animateTweetInsertion(element);
      this.observeVisibleTweets();
    }
  }, {
    key: "insertThreadReply",
    value: function insertThreadReply(tweet) {
      if (!tweet || tweet.parent_id !== this.active_signature) {
        return;
      }
      var container = "".concat(this.container, " .list[data-panel=\"thread\"]");
      var panel = document.querySelector(container);
      if (!panel) {
        return;
      }
      var focusedEl = panel.querySelector("article.tweet[data-id=\"".concat(this.active_signature, "\"]"));
      var replies = panel.querySelectorAll("article.tweet:not([data-id=\"".concat(this.active_signature, "\"])"));
      var lastReply = replies.length ? replies[replies.length - 1] : null;
      var anchor = lastReply || focusedEl;
      var options = {
        presentation: 'reply',
        reply: true
      };
      var html = TweetTemplate(tweet, tweet.buildClassName(options), options);
      if (anchor) {
        anchor.insertAdjacentHTML('afterend', html);
      } else {
        this.app.browser.addElementToSelector(html, container);
      }
      if (!this.pagination.thread.chain.includes(tweet.signature)) {
        this.pagination.thread.chain.push(tweet.signature);
      }
      this.pagination.thread.cursor += 1;
      var element = panel.querySelector("article.tweet[data-id=\"".concat(tweet.signature, "\"]"));
      this.animateTweetInsertion(element);
    }
  }, {
    key: "animateTweetInsertion",
    value: function animateTweetInsertion(element) {
      if (!element) {
        return;
      }
      element.classList.add('enter');
      var _onEnd = function onEnd() {
        element.classList.remove('enter');
        element.removeEventListener('animationend', _onEnd);
      };
      element.addEventListener('animationend', _onEnd);
    }
  }, {
    key: "renderTweetWithCriticalChild",
    value: function renderTweetWithCriticalChild(tweet, container) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.renderTweetChain(tweet, container, options, false);
    }
  }, {
    key: "renderCriticalChildChain",
    value: function renderCriticalChildChain(tweet, container) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.renderTweetChain(tweet, container, options, true);
    }
  }, {
    key: "renderTweetChain",
    value: function renderTweetChain(tweet, container) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var followFullChain = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      if (!tweet) {
        return;
      }
      var child = tweet.critical_child ? this.mod.getTweet(tweet.critical_child) : null;
      var renderOptions = _objectSpread({}, options);
      if (child) {
        renderOptions.chainNext = true;
        renderOptions.chainContinue = true;
        // Parent of a critical-child stub reads as conversation root.
        if (!renderOptions.presentation && !renderOptions.focused) {
          renderOptions.presentation = 'root';
          renderOptions.root = true;
        }
      }
      tweet.render(container, renderOptions);
      if (!child) {
        return;
      }
      var childOptions = {
        chainPrev: true,
        presentation: 'reply',
        reply: true
      };
      if (followFullChain) {
        this.renderTweetChain(child, container, childOptions, true);
        return;
      }
      child.render(container, childOptions);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      this.attachTweetNavigation(root);
      this.attachTweetImageViewer(root);
      this.attachThreadContext(root);
      this.attachTweetMenu(root);
      this.attachTweetReply(root);
      this.attachTweetLike(root);
      this.attachTweetRetweet(root);
      this.attachTweetShare(root);
      this.attachFeedHeaderBack(root);
      this.attachPermalinkRetry(root);
      this.attachScrollEvents();
      this.attachViewportChrome();
      this.attachBrowserHistory();
      this.observeVisibleTweets();
    }
  }, {
    key: "attachViewportChrome",
    value: function attachViewportChrome() {
      var _this1 = this;
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
        return;
      }
      if (this._viewportChromeBound) {
        return;
      }
      this._viewportChromeBound = true;
      this._compactViewportQuery = window.matchMedia('(max-width: 600px)');
      var onChange = function onChange() {
        _this1.syncFeedHeader();
      };
      if (typeof this._compactViewportQuery.addEventListener === 'function') {
        this._compactViewportQuery.addEventListener('change', onChange);
      } else if (typeof this._compactViewportQuery.addListener === 'function') {
        this._compactViewportQuery.addListener(onChange);
      }
    }
  }, {
    key: "attachFeedHeaderBack",
    value: function attachFeedHeaderBack(root) {
      var _this10 = this;
      if (!root || root.dataset.feedHeaderBackBound === '1') {
        return;
      }
      root.dataset.feedHeaderBackBound = '1';
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('.back');
        if (!btn || !root.contains(btn) || btn.hidden) {
          return;
        }
        e.preventDefault();
        _this10.navigateBackToTimeline();
      });
    }
  }, {
    key: "attachPermalinkRetry",
    value: function attachPermalinkRetry(root) {
      var _this11 = this;
      if (!root || root.dataset.permalinkRetryBound === '1') {
        return;
      }
      root.dataset.permalinkRetryBound = '1';
      root.addEventListener('click', function (e) {
        var retry = e.target.closest('.feed-status .retry, .feed-status .check-again');
        if (!retry || !root.contains(retry) || retry.hidden) {
          return;
        }
        e.preventDefault();
        if (_this11.mode === 'timeline') {
          var state = _this11.pagination.timeline;
          if (!state.error || state.loading || _this11._timeline_bootstrapping) {
            return;
          }
          var direction = state.error.direction;
          state.error = null;
          if (direction === 'newer') {
            _this11.timeline_rendered = false;
            _this11.bootstrapTimeline();
          } else {
            _this11.loadMoreIfNeeded();
          }
        } else if (_this11.isProfileMode()) {
          var _state = _this11.getPaginationState();
          var source = _this11.getActiveProfileSource();
          if (!_state.error || _state.loading || source.loading) {
            return;
          }
          _state.error = null;
          source.error = null;
          _this11.loadMoreIfNeeded();
        } else if (_this11.pending_route_signature) {
          _this11.applyLocationRoute({
            refresh: true
          });
        }
      });
    }
  }, {
    key: "attachThreadContext",
    value: function attachThreadContext(root) {
      var _this12 = this;
      if (!root || root.dataset.threadContextBound === '1') {
        return;
      }
      root.dataset.threadContextBound = '1';
      root.addEventListener('click', function (e) {
        var link = e.target.closest('.thread-context');
        if (!link) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        var rootSignature = link.getAttribute('data-root') || '';
        if (rootSignature) {
          _this12.openEntireThread(rootSignature);
        }
      });
    }
  }, {
    key: "openEntireThread",
    value: function () {
      var _openEntireThread = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(rootSignature) {
        var result, status, _t4;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              if (rootSignature) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2, null);
            case 1:
              // Paint anything already in memory, then load the archive thread. The
              // tweet does not need to be cached first — permalink and click-through
              // share this path.
              this.renderThread(rootSignature);
              _context7.p = 2;
              _context7.n = 3;
              return this.mod.loadTweetThread(rootSignature);
            case 3:
              result = _context7.v;
              if (!(this.mode !== 'thread' || this.active_signature !== rootSignature)) {
                _context7.n = 4;
                break;
              }
              return _context7.a(2, result);
            case 4:
              if ((result === null || result === void 0 ? void 0 : result.status) === 'loaded' && result.tweet) {
                this.renderThread(rootSignature, {
                  updateHistory: false
                });
              } else if (!this.mod.getTweet(rootSignature)) {
                status = (result === null || result === void 0 ? void 0 : result.status) === 'unavailable' ? 'unavailable' : 'error';
                this.renderPermalinkState(rootSignature, status, result === null || result === void 0 ? void 0 : result.reason);
              }
              return _context7.a(2, result);
            case 5:
              _context7.p = 5;
              _t4 = _context7.v;
              console.error('RedSquare complete thread lookup failed:', _t4);
              if (this.mode === 'thread' && this.active_signature === rootSignature && !this.mod.getTweet(rootSignature)) {
                this.renderPermalinkState(rootSignature, 'error', 'lookup-failed');
              }
              return _context7.a(2, {
                status: 'error',
                reason: 'lookup-failed',
                tweet: null
              });
          }
        }, _callee7, this, [[2, 5]]);
      }));
      function openEntireThread(_x4) {
        return _openEntireThread.apply(this, arguments);
      }
      return openEntireThread;
    }()
  }, {
    key: "attachTweetReply",
    value: function attachTweetReply(root) {
      var _this13 = this;
      if (!root || root.dataset.tweetReplyBound === '1') {
        return;
      }
      root.dataset.tweetReplyBound = '1';
      root.addEventListener('click', function (e) {
        var replyButton = e.target.closest('.tool.comment');
        if (!replyButton) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        var tweetArticle = replyButton.closest('article.tweet');
        var signature = (tweetArticle === null || tweetArticle === void 0 ? void 0 : tweetArticle.getAttribute('data-id')) || '';
        var tweet = _this13.mod.getTweet(signature);
        if (tweet) {
          var _this13$mod$compose_o;
          (_this13$mod$compose_o = _this13.mod.compose_overlay) === null || _this13$mod$compose_o === void 0 || _this13$mod$compose_o.open({
            reply_to: tweet,
            mode: 'reply'
          });
        }
      });
    }
  }, {
    key: "attachTweetLike",
    value: function attachTweetLike(root) {
      var _this14 = this;
      if (!root || root.dataset.tweetLikeBound === '1') {
        return;
      }
      root.dataset.tweetLikeBound = '1';
      root.addEventListener('click', /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(e) {
          var _tweet$tx;
          var likeButton, tweetArticle, signature, tweet, keys, _iterator9, _step9, slip, publicKey, wasLiked, heart, unsigned, _t5;
          return _regenerator().w(function (_context8) {
            while (1) switch (_context8.p = _context8.n) {
              case 0:
                likeButton = e.target.closest('.tool.like');
                if (likeButton) {
                  _context8.n = 1;
                  break;
                }
                return _context8.a(2);
              case 1:
                e.preventDefault();
                e.stopPropagation();
                tweetArticle = likeButton.closest('article.tweet');
                signature = (tweetArticle === null || tweetArticle === void 0 ? void 0 : tweetArticle.getAttribute('data-id')) || '';
                tweet = _this14.mod.getTweet(signature);
                if (tweet !== null && tweet !== void 0 && tweet.signature) {
                  _context8.n = 2;
                  break;
                }
                return _context8.a(2);
              case 2:
                keys = [];
                if (tweet.publicKey) {
                  keys.push(tweet.publicKey);
                }
                if ((_tweet$tx = tweet.tx) !== null && _tweet$tx !== void 0 && _tweet$tx.to) {
                  _iterator9 = _createForOfIteratorHelper(tweet.tx.to);
                  try {
                    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                      slip = _step9.value;
                      publicKey = slip === null || slip === void 0 ? void 0 : slip.publicKey;
                      if (publicKey && !keys.includes(publicKey)) {
                        keys.push(publicKey);
                      }
                    }
                  } catch (err) {
                    _iterator9.e(err);
                  } finally {
                    _iterator9.f();
                  }
                }
                wasLiked = likeButton.classList.contains('liked');
                heart = likeButton.querySelector('.heart');
                likeButton.classList.add('liked');
                if (heart) {
                  heart.classList.remove('animating');
                  // Restart the animation for successive likes without moving the count.
                  void heart.offsetWidth;
                  heart.classList.add('animating');
                  heart.onanimationend = function (event) {
                    if (event.animationName === 'redsquare-heart-pulse') {
                      heart.classList.remove('animating');
                      heart.onanimationend = null;
                    }
                  };
                }
                _context8.p = 3;
                _context8.n = 4;
                return _this14.mod.createLikeTweetTransaction({
                  signature: tweet.signature
                }, keys);
              case 4:
                unsigned = _context8.v;
                _context8.n = 5;
                return unsigned.sign();
              case 5:
                _context8.n = 6;
                return _this14.app.network.propagateTransaction(unsigned);
              case 6:
                _context8.n = 7;
                return _this14.mod.receiveLikeTweetTransaction(unsigned);
              case 7:
                _context8.n = 9;
                break;
              case 8:
                _context8.p = 8;
                _t5 = _context8.v;
                likeButton.classList.toggle('liked', wasLiked);
                heart === null || heart === void 0 || heart.classList.remove('animating');
                if (heart) heart.onanimationend = null;
                console.error('RedSquare like failed:', _t5);
                siteMessage('Unable to like tweet', 2500);
              case 9:
                return _context8.a(2);
            }
          }, _callee8, null, [[3, 8]]);
        }));
        return function (_x5) {
          return _ref8.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "attachTweetRetweet",
    value: function attachTweetRetweet(root) {
      var _this15 = this;
      if (!root || root.dataset.tweetRetweetBound === '1') {
        return;
      }
      root.dataset.tweetRetweetBound = '1';
      root.addEventListener('click', function (e) {
        var retweetButton = e.target.closest('.tool.retweet');
        if (!retweetButton) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        var tweetArticle = retweetButton.closest('article.tweet');
        var signature = (tweetArticle === null || tweetArticle === void 0 ? void 0 : tweetArticle.getAttribute('data-id')) || '';
        var tweet = _this15.mod.getTweet(signature);
        if (tweet) {
          var _this15$mod$compose_o;
          (_this15$mod$compose_o = _this15.mod.compose_overlay) === null || _this15$mod$compose_o === void 0 || _this15$mod$compose_o.open({
            mode: 'retweet',
            retweet_of: tweet
          });
        }
      });
    }
  }, {
    key: "attachTweetShare",
    value: function attachTweetShare(root) {
      var _this16 = this;
      if (!root || root.dataset.tweetShareBound === '1') {
        return;
      }
      root.dataset.tweetShareBound = '1';
      root.addEventListener('click', /*#__PURE__*/function () {
        var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(e) {
          var shareButton, tweetArticle, signature, longUrl, url, _t6;
          return _regenerator().w(function (_context9) {
            while (1) switch (_context9.p = _context9.n) {
              case 0:
                shareButton = e.target.closest('.tool.share');
                if (shareButton) {
                  _context9.n = 1;
                  break;
                }
                return _context9.a(2);
              case 1:
                e.preventDefault();
                e.stopPropagation();
                tweetArticle = shareButton.closest('article.tweet');
                signature = (tweetArticle === null || tweetArticle === void 0 ? void 0 : tweetArticle.getAttribute('data-id')) || '';
                if (signature) {
                  _context9.n = 2;
                  break;
                }
                return _context9.a(2);
              case 2:
                longUrl = _this16.mod.returnTweetUrl(signature);
                _context9.p = 3;
                _context9.n = 4;
                return _this16.mod.createShortLink(longUrl);
              case 4:
                url = _context9.v;
                _this16.app.browser.handleShare({
                  title: 'Saito RedSquare Tweet',
                  url: url
                });
                _context9.n = 6;
                break;
              case 5:
                _context9.p = 5;
                _t6 = _context9.v;
                console.error('RedSquare share failed:', _t6);
                _this16.app.browser.handleShare({
                  title: 'Saito RedSquare Tweet',
                  url: longUrl
                });
              case 6:
                return _context9.a(2);
            }
          }, _callee9, null, [[3, 5]]);
        }));
        return function (_x6) {
          return _ref9.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "attachTweetMenu",
    value: function attachTweetMenu(root) {
      var _this17 = this;
      if (!root || root.dataset.tweetMenuBound === '1') {
        return;
      }
      root.dataset.tweetMenuBound = '1';
      root.addEventListener('click', function (e) {
        var _this17$mod$tweet_men;
        var moreButton = e.target.closest('.tool.more');
        if (!moreButton) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        var tweetArticle = moreButton.closest('article.tweet');
        if (!tweetArticle) {
          return;
        }
        var signature = tweetArticle.getAttribute('data-id') || '';
        if (!signature) {
          return;
        }
        var tweet = _this17.mod.getTweet(signature);
        if (!tweet) {
          return;
        }
        (_this17$mod$tweet_men = _this17.mod.tweet_menu) === null || _this17$mod$tweet_men === void 0 || _this17$mod$tweet_men.toggle({
          anchor: moreButton,
          tweet: tweet
        });
      });
    }
  }, {
    key: "attachTweetNavigation",
    value: function attachTweetNavigation(root) {
      var _this18 = this;
      if (!root || root.dataset.tweetNavigationBound === '1') {
        return;
      }
      root.dataset.tweetNavigationBound = '1';
      root.addEventListener('click', function (e) {
        if (window.getSelection && !window.getSelection().isCollapsed) {
          return;
        }
        var signature = Manager.resolveClickedSignature(e.target);
        if (!signature) {
          return;
        }
        var tweet = _this18.mod.getTweet(signature);
        if (tweet !== null && tweet !== void 0 && tweet.ephemeral) {
          var href = String(tweet.href || '').trim();
          if (!href) {
            return;
          }
          e.preventDefault();
          e.stopPropagation();
          if (typeof navigateWindow === 'function') {
            navigateWindow(href);
          } else if (typeof window !== 'undefined') {
            window.location.assign(href);
          }
          return;
        }
        _this18.openEntireThread(signature);
      });
    }
  }, {
    key: "attachTweetImageViewer",
    value: function attachTweetImageViewer(root) {
      var _this19 = this;
      if (!root || root.dataset.tweetImageViewerBound === '1') {
        return;
      }
      root.dataset.tweetImageViewerBound = '1';
      var openImage = function openImage(image) {
        var gallery = image.closest('.gallery');
        var galleryImages = gallery ? Array.from(gallery.querySelectorAll('.grid img')) : [];
        var imageIndex = galleryImages.indexOf(image);
        var images = galleryImages.map(function (galleryImage) {
          return galleryImage.getAttribute('src') || '';
        }).filter(Boolean);
        if (imageIndex < 0 || images.length === 0) {
          return;
        }
        _this19.image_overlay = new SaitoImageOverlay(_this19.app, _this19.mod, images);
        _this19.image_overlay.render(imageIndex);
      };
      root.addEventListener('click', function (e) {
        var image = e.target.closest('.gallery img');
        if (!image || !root.contains(image)) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        openImage(image);
      });
      root.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') {
          return;
        }
        var image = e.target.closest('.gallery img');
        if (!image || !root.contains(image)) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        openImage(image);
      });
    }
  }, {
    key: "attachScrollEvents",
    value: function attachScrollEvents() {
      var _this20 = this;
      var scroller = this.getScrollContainer();
      if (scroller === this._scroll_container) {
        return;
      }
      if (this._scroll_container && this._scroll_handler) {
        this._scroll_container.removeEventListener('scroll', this._scroll_handler);
      }
      if (this.scroll_raf !== null) {
        cancelAnimationFrame(this.scroll_raf);
        this.scroll_raf = null;
      }
      this._scroll_container = scroller;
      this._scroll_handler = null;
      if (!scroller) {
        return;
      }
      this._scroll_handler = function () {
        if (_this20.getScrollContainer() !== scroller || _this20.scroll_raf !== null) {
          return;
        }
        _this20.scroll_raf = requestAnimationFrame(function () {
          if (_this20._scroll_container !== scroller) {
            return;
          }
          _this20.scroll_raf = null;
          if (_this20.getScrollContainer() === scroller) {
            _this20.onScroll();
          }
        });
      };
      scroller.addEventListener('scroll', this._scroll_handler, {
        passive: true
      });
    }
  }, {
    key: "ensureReadObserver",
    value: function ensureReadObserver() {
      var _this$_read_observer,
        _this21 = this;
      if (typeof IntersectionObserver === 'undefined') {
        return;
      }
      var scroller = this.getScrollContainer();
      if (!scroller) {
        return;
      }
      if (this._read_observer && this._read_observer_root === scroller) {
        return;
      }
      (_this$_read_observer = this._read_observer) === null || _this$_read_observer === void 0 || _this$_read_observer.disconnect();
      this._read_observer_root = scroller;
      this._read_observer = new IntersectionObserver(function (entries) {
        return _this21.onTweetIntersection(entries);
      }, {
        root: scroller,
        threshold: 0.5
      });
    }
  }, {
    key: "observeVisibleTweets",
    value: function observeVisibleTweets() {
      if (this.mode !== 'timeline') {
        return;
      }
      this.ensureReadObserver();
      if (!this._read_observer) {
        return;
      }
      var panel = document.querySelector("".concat(this.container, " .list[data-panel=\"timeline\"]"));
      var _iterator0 = _createForOfIteratorHelper((panel === null || panel === void 0 ? void 0 : panel.querySelectorAll('article.tweet[data-id]')) || []),
        _step0;
      try {
        for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
          var element = _step0.value;
          this._read_observer.observe(element);
        }
      } catch (err) {
        _iterator0.e(err);
      } finally {
        _iterator0.f();
      }
    }
  }, {
    key: "onTweetIntersection",
    value: function onTweetIntersection(entries) {
      if (this.mode !== 'timeline') {
        return;
      }
      var newestSeen = Number(this.mod.tweets_last_viewed_ts) || 0;
      var _iterator1 = _createForOfIteratorHelper(entries),
        _step1;
      try {
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          var entry = _step1.value;
          if (!entry.isIntersecting) {
            continue;
          }
          var signature = entry.target.getAttribute('data-id') || '';
          var tweet = this.mod.getTweet(signature);
          if (!tweet || tweet.parent_id) {
            continue;
          }
          newestSeen = Math.max(newestSeen, Number(tweet.created_at) || 0);
        }
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
      if (newestSeen <= (Number(this.mod.tweets_last_viewed_ts) || 0)) {
        return;
      }
      this.mod.tweets_last_viewed_ts = newestSeen;
      this.scheduleSaveReadCursor();
    }
  }, {
    key: "scheduleSaveReadCursor",
    value: function scheduleSaveReadCursor() {
      var _this22 = this;
      if (this._read_save_timer) {
        clearTimeout(this._read_save_timer);
      }
      this._read_save_timer = setTimeout(function () {
        _this22._read_save_timer = null;
        _this22.mod.saveOptions();
      }, 750);
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      var scroller = this.getScrollContainer();
      this._last_scroll_top = scroller ? scroller.scrollTop : 0;
      if (this.mode === 'timeline') {
        this.observeVisibleTweets();
      }
      if (!this.isNearBottom()) {
        return;
      }
      this.loadMoreIfNeeded();
    }
  }, {
    key: "isNearBottom",
    value: function isNearBottom() {
      var scroller = this.getScrollContainer();
      if (!scroller) {
        return false;
      }
      var remaining = scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight;
      return remaining <= Math.max(SCROLL_THRESHOLD_PX, scroller.clientHeight);
    }
  }, {
    key: "isNearTop",
    value: function isNearTop() {
      var scroller = this.getScrollContainer();
      if (!scroller) {
        return true;
      }
      return scroller.scrollTop <= SCROLL_THRESHOLD_PX;
    }
  }, {
    key: "getRenderedTimelineSignatures",
    value: function getRenderedTimelineSignatures() {
      var rendered = new Set();
      var panel = document.querySelector("".concat(this.container, " .list[data-panel=\"timeline\"]"));
      var _iterator10 = _createForOfIteratorHelper((panel === null || panel === void 0 ? void 0 : panel.querySelectorAll('article.tweet[data-id]')) || []),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var element = _step10.value;
          var signature = element.getAttribute('data-id') || '';
          if (signature) {
            rendered.add(signature);
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      return rendered;
    }
  }, {
    key: "captureScrollAnchor",
    value: function captureScrollAnchor() {
      var scroller = this.getScrollContainer();
      var panel = document.querySelector("".concat(this.container, " .list[data-panel=\"timeline\"]"));
      if (!scroller || !panel) {
        return null;
      }
      var scrollerTop = scroller.getBoundingClientRect().top;
      var _iterator11 = _createForOfIteratorHelper(panel.querySelectorAll('article.tweet[data-id]')),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var element = _step11.value;
          var signature = element.getAttribute('data-id') || '';
          var tweet = this.mod.getTweet(signature);
          if (!tweet || tweet.parent_id) {
            continue;
          }
          var rect = element.getBoundingClientRect();
          if (rect.bottom > scrollerTop + 8) {
            return {
              signature: signature,
              offset: rect.top - scrollerTop
            };
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      return null;
    }
  }, {
    key: "restoreScrollAnchor",
    value: function restoreScrollAnchor(anchor) {
      if (!(anchor !== null && anchor !== void 0 && anchor.signature)) {
        return;
      }
      var scroller = this.getScrollContainer();
      var element = document.querySelector("".concat(this.container, " article.tweet[data-id=\"").concat(anchor.signature, "\"]"));
      if (!scroller || !element) {
        return;
      }
      var scrollerTop = scroller.getBoundingClientRect().top;
      var rect = element.getBoundingClientRect();
      scroller.scrollTop += rect.top - scrollerTop - (anchor.offset || 0);
    }
  }, {
    key: "requestTweetLoad",
    value: function requestTweetLoad(direction) {
      var _this23 = this;
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new Promise(function (resolve) {
        var settled = false;
        var finish = function finish(result) {
          if (settled) {
            return;
          }
          settled = true;
          resolve(result || {
            type: 'tweets',
            direction: direction,
            added: [],
            new_tweets: [],
            updated: [],
            ignored: [],
            failed: true,
            exhausted: false
          });
        };
        try {
          _this23.mod.loadTransactions('tweets', direction, function (result) {
            finish(result);
          }, extra);
        } catch (err) {
          finish(null);
        }
      });
    }
  }, {
    key: "onPeersUpdated",
    value: function () {
      var _onPeersUpdated = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var source, result;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              if (this.container) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              this.pagination.timeline.exhausted = false;
              this._peer_history_pending = true;
              if (this.pending_route_signature || this.mod.returnTweetSignatureFromLocation()) {
                this.applyLocationRoute({
                  refresh: true
                });
              }
              if (this.isProfileMode()) {
                source = this.getActiveProfileSource();
                source.exhausted = false;
                this.getPaginationState().exhausted = false;
                this.loadMoreIfNeeded();
              }
              if (!(this.mode !== 'timeline')) {
                _context0.n = 2;
                break;
              }
              this.resumePeerHistory();
              return _context0.a(2);
            case 2:
              if (!this._timeline_bootstrapping) {
                _context0.n = 3;
                break;
              }
              return _context0.a(2);
            case 3:
              if (this.timeline_rendered) {
                _context0.n = 4;
                break;
              }
              this.paintTimeline();
              return _context0.a(2);
            case 4:
              this._peer_timeline_refreshes++;
              _context0.p = 5;
              _context0.n = 6;
              return this.requestTweetLoad('newer');
            case 6:
              result = _context0.v;
              this.onNewerContentLoaded(result, {
                announce: !this.isNearTop()
              });
            case 7:
              _context0.p = 7;
              this._peer_timeline_refreshes--;
              this.resumePeerHistory();
              return _context0.f(7);
            case 8:
              return _context0.a(2);
          }
        }, _callee0, this, [[5,, 7, 8]]);
      }));
      function onPeersUpdated() {
        return _onPeersUpdated.apply(this, arguments);
      }
      return onPeersUpdated;
    }()
  }, {
    key: "resumePeerHistory",
    value: function resumePeerHistory() {
      if (!this._peer_history_pending || this._timeline_bootstrapping || this.pagination.timeline.loading || this._peer_timeline_refreshes) {
        return;
      }
      this._peer_history_pending = false;
      this.onTweetHistoryAvailable();
    }
  }, {
    key: "onNewerContentLoaded",
    value: function onNewerContentLoaded(result) {
      var _ref0 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref0$announce = _ref0.announce,
        announce = _ref0$announce === void 0 ? false : _ref0$announce;
      if (!result) {
        return;
      }
      if (result.type === 'tweets') {
        this.handleNewerTweets(result, {
          announce: announce
        });
        if (result.history_reopened) {
          this.onTweetHistoryAvailable();
        }
        return;
      }
      if (result.type === 'notifications' && this.mode === 'notifications') {
        this.handleNewerNotifications(result);
      }
    }
  }, {
    key: "onTweetHistoryAvailable",
    value: function onTweetHistoryAvailable() {
      this.pagination.timeline.exhausted = false;
      if (this.mode === 'timeline') {
        this.syncFeedStatus();
        if (this.isNearBottom() && !this._peer_timeline_refreshes) {
          this.loadMoreIfNeeded();
        }
      }
    }
  }, {
    key: "handleNewerTweets",
    value: function handleNewerTweets(result) {
      var _this24 = this;
      var _ref1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref1$announce = _ref1.announce,
        announce = _ref1$announce === void 0 ? false : _ref1$announce;
      this.syncConfirmedTweetRenders(result);
      var rendered = this.getRenderedTimelineSignatures();
      if (this.mode === 'timeline' && !this._timeline_bootstrapping && this.timeline_rendered && rendered.size === 0) {
        // An empty feed has no reading position to protect with a banner.
        // Include historical roots as well as newly announced tweets.
        this.pending_newer_tweets = [];
        this.hideNewPostsBanner();
        if (this.fillTimelineToViewport() > 0) {
          this.pagination.timeline.exhausted = false;
        }
        this.syncFeedStatus();
        return;
      }
      var signatures = Array.from(new Set(announce ? Array.isArray(result === null || result === void 0 ? void 0 : result.new_tweets) ? result.new_tweets : [] : Array.isArray(result === null || result === void 0 ? void 0 : result.added) ? result.added : []));
      var unrenderedRoots = signatures.filter(function (signature) {
        var tweet = _this24.mod.getTweet(signature);
        return Boolean(tweet && !tweet.parent_id && !rendered.has(signature));
      });
      if (!unrenderedRoots.length) {
        return;
      }
      if (this.mode !== 'timeline' || this._timeline_bootstrapping || !this.timeline_rendered) {
        var _iterator12 = _createForOfIteratorHelper(unrenderedRoots),
          _step12;
        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var signature = _step12.value;
            if (!this.pending_newer_tweets.includes(signature)) {
              this.pending_newer_tweets.push(signature);
            }
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
        return;
      }
      if (announce || !this.isNearTop()) {
        var _iterator13 = _createForOfIteratorHelper(unrenderedRoots),
          _step13;
        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var _signature2 = _step13.value;
            if (!this.pending_newer_tweets.includes(_signature2)) {
              this.pending_newer_tweets.push(_signature2);
            }
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
        this.showNewPostsBanner();
        return;
      }
      this.prependTimelineTweets(unrenderedRoots);
    }
  }, {
    key: "syncConfirmedTweetRenders",
    value: function syncConfirmedTweetRenders(result) {
      var signatures = [].concat((result === null || result === void 0 ? void 0 : result.added) || [], (result === null || result === void 0 ? void 0 : result.new_tweets) || [], (result === null || result === void 0 ? void 0 : result.updated) || []);
      var seen = new Set();
      var _iterator14 = _createForOfIteratorHelper(signatures),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var signature = _step14.value;
          if (!signature || seen.has(signature)) {
            continue;
          }
          seen.add(signature);
          var tweet = this.mod.getTweet(signature);
          if (!(tweet !== null && tweet !== void 0 && tweet.parent_id)) {
            continue;
          }
          var parent = this.mod.getTweet(tweet.parent_id);
          if (parent) {
            this.refreshParentCriticalChild(parent);
          }
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
    }
  }, {
    key: "refreshParentCriticalChild",
    value: function refreshParentCriticalChild(parent) {
      if (!parent || this.mode !== 'timeline') {
        return;
      }
      var panel = document.querySelector("".concat(this.container, " .list[data-panel=\"timeline\"]"));
      var parentEl = panel === null || panel === void 0 ? void 0 : panel.querySelector("article.tweet[data-id=\"".concat(parent.signature, "\"]"));
      if (!parentEl) {
        return;
      }
      var child = parent.critical_child ? this.mod.getTweet(parent.critical_child) : null;
      parent.refresh();
      if (!child) {
        return;
      }
      var panelAfter = document.querySelector("".concat(this.container, " .list[data-panel=\"timeline\"]"));
      var existingChild = panelAfter === null || panelAfter === void 0 ? void 0 : panelAfter.querySelector("article.tweet[data-id=\"".concat(child.signature, "\"]"));
      if (existingChild) {
        child.refresh();
        return;
      }
      var parentNode = panelAfter === null || panelAfter === void 0 ? void 0 : panelAfter.querySelector("article.tweet[data-id=\"".concat(parent.signature, "\"]"));
      if (!parentNode) {
        return;
      }
      parentNode.classList.add('chain-next', 'chain-continue');
      var childOptions = {
        chainPrev: true,
        presentation: 'reply',
        reply: true
      };
      parentNode.insertAdjacentHTML('afterend', TweetTemplate(child, child.buildClassName(childOptions), childOptions));
    }
  }, {
    key: "syncPendingNewerTweets",
    value: function syncPendingNewerTweets() {
      if (!this.pending_newer_tweets.length) {
        this.hideNewPostsBanner();
        return;
      }
      if (this.mode === 'timeline') {
        this.showNewPostsBanner();
      }
    }
  }, {
    key: "handleNewerNotifications",
    value: function handleNewerNotifications(result) {
      var _result$added;
      if (!(result !== null && result !== void 0 && (_result$added = result.added) !== null && _result$added !== void 0 && _result$added.length)) {
        return;
      }
      this.prependNotifications(result.added);
      this.pagination.notifications.exhausted = false;
      this.syncFeedStatus();
    }
  }, {
    key: "prependTimelineTweets",
    value: function prependTimelineTweets(signatures) {
      var _this25 = this;
      var container = "".concat(this.container, " .list[data-panel=\"timeline\"]");
      var panel = document.querySelector(container);
      if (!panel || !(signatures !== null && signatures !== void 0 && signatures.length)) {
        return;
      }
      var tweets = signatures.map(function (signature) {
        return _this25.mod.getTweet(signature);
      }).filter(function (tweet) {
        return tweet && !tweet.parent_id;
      }).sort(function (a, b) {
        return (a.created_at || 0) - (b.created_at || 0);
      });
      var _iterator15 = _createForOfIteratorHelper(tweets),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var tweet = _step15.value;
          var child = tweet.critical_child ? this.mod.getTweet(tweet.critical_child) : null;
          var options = {};
          if (child) {
            options.chainNext = true;
            options.chainContinue = true;
            options.presentation = 'root';
            options.root = true;
          }
          var html = TweetTemplate(tweet, tweet.buildClassName(options), options);
          this.app.browser.prependElementToSelector(html, container);
          if (child) {
            var childOptions = {
              chainPrev: true,
              presentation: 'reply',
              reply: true
            };
            var childHtml = TweetTemplate(child, child.buildClassName(childOptions), childOptions);
            var parentEl = panel.querySelector("article.tweet[data-id=\"".concat(tweet.signature, "\"]"));
            if (parentEl) {
              parentEl.insertAdjacentHTML('afterend', childHtml);
            }
          }
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
      this.timeline_rendered = true;
      this.observeVisibleTweets();
    }
  }, {
    key: "prependNotifications",
    value: function prependNotifications(signatures) {
      var _this26 = this,
        _this$mod$moderate,
        _this$mod$moderate$en;
      var container = "".concat(this.container, " .list[data-panel=\"notifications\"]");
      var panel = document.querySelector(container);
      if (!panel || !(signatures !== null && signatures !== void 0 && signatures.length)) {
        return;
      }
      var notifications = signatures.map(function (signature) {
        return _this26.mod.getNotification(signature);
      }).filter(Boolean).sort(function (a, b) {
        return (a.created_at || 0) - (b.created_at || 0);
      });
      var _iterator16 = _createForOfIteratorHelper(notifications),
        _step16;
      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var notification = _step16.value;
          var html = notification.renderHTML();
          if (html) {
            this.app.browser.prependElementToSelector(html, container);
          }
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
      this.pagination.notifications.cursor += signatures.length;
      this.notifications_rendered = true;
      (_this$mod$moderate = this.mod.moderate) === null || _this$mod$moderate === void 0 || (_this$mod$moderate$en = _this$mod$moderate.ensureTop) === null || _this$mod$moderate$en === void 0 || _this$mod$moderate$en.call(_this$mod$moderate);
    }
  }, {
    key: "showNewPostsBanner",
    value: function showNewPostsBanner() {
      var _this27 = this;
      if (!this.pending_newer_tweets.length || this.mode !== 'timeline') {
        return;
      }
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      var banner = root.querySelector('.new-posts-banner');
      if (!banner) {
        var body = root.querySelector('.body');
        var host = (body === null || body === void 0 ? void 0 : body.parentElement) || root;
        banner = document.createElement('button');
        banner.className = 'new-posts-banner';
        banner.type = 'button';
        banner.textContent = 'New tweets available';
        banner.addEventListener('click', function () {
          _this27.revealPendingNewerTweets();
        });
        if (body && host) {
          host.insertBefore(banner, body);
        } else {
          host.prepend(banner);
        }
      }
      banner.hidden = false;
    }
  }, {
    key: "hideNewPostsBanner",
    value: function hideNewPostsBanner() {
      var banner = document.querySelector("".concat(this.container, " .new-posts-banner"));
      if (!banner) {
        return;
      }
      banner.hidden = true;
    }
  }, {
    key: "revealPendingNewerTweets",
    value: function revealPendingNewerTweets() {
      this.flushPendingNewerTweets({
        scrollToTop: true
      });
    }
  }, {
    key: "flushPendingNewerTweets",
    value: function flushPendingNewerTweets() {
      var _this28 = this;
      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref10$scrollToTop = _ref10.scrollToTop,
        scrollToTop = _ref10$scrollToTop === void 0 ? false : _ref10$scrollToTop;
      var rendered = this.getRenderedTimelineSignatures();
      var signatures = this.pending_newer_tweets.filter(function (signature) {
        return !rendered.has(signature);
      });
      this.pending_newer_tweets = [];
      this.hideNewPostsBanner();
      if (signatures.length) {
        this.prependTimelineTweets(signatures);
        this.pagination.timeline.exhausted = false;
        this.syncFeedStatus();
      }
      if (scrollToTop) {
        requestAnimationFrame(function () {
          var scroller = _this28.getScrollContainer();
          if (scroller) {
            scroller.scrollTop = 0;
          }
        });
      }
    }
  }, {
    key: "sliceUnrendered",
    value: function sliceUnrendered(signatures, cursor, batchSize) {
      if (cursor >= signatures.length) {
        return [];
      }
      return signatures.slice(cursor, cursor + batchSize);
    }
  }, {
    key: "loadMoreIfNeeded",
    value: function loadMoreIfNeeded() {
      var state = this.getPaginationState();
      if (state.loading || state.exhausted || state.error || this.mode === 'notifications' && this._notifications_bootstrapping || this.mode === 'timeline' && this._timeline_bootstrapping) {
        return;
      }
      this.loadMore();
    }
  }, {
    key: "getOlderLoadCursors",
    value: function getOlderLoadCursors(mode) {
      if (mode === 'timeline') {
        return new Map((this.mod.peers || []).map(function (source) {
          return [source, Number(source.tweets_earliest_ts) || 0];
        }));
      }
      if (this.isProfileViewMode(mode)) {
        return new Map(Object.entries(this.getActiveProfileSource().peers).map(function (_ref11) {
          var _ref12 = _slicedToArray(_ref11, 2),
            key = _ref12[0],
            source = _ref12[1];
          return [key, Number(source.cursor) || 0];
        }));
      }
      if (mode === 'notifications') {
        return new Map([['likes', Number(this.mod.notifications_earliest_like_ts) || 0], ['retweets', Number(this.mod.notifications_earliest_retweet_ts) || 0]].concat(_toConsumableArray(Object.entries(this.mod.notifications_contact_earliest_ts || {}).map(function (_ref13) {
          var _ref14 = _slicedToArray(_ref13, 2),
            key = _ref14[0],
            cursor = _ref14[1];
          return ["contact:".concat(key), Number(cursor) || 0];
        }))));
      }
      return new Map();
    }
  }, {
    key: "scheduleLoadMore",
    value: function scheduleLoadMore(mode, state) {
      var _this29 = this;
      if (this._load_more_timer !== null) {
        clearTimeout(this._load_more_timer);
      }
      this._load_more_timer = setTimeout(function () {
        _this29._load_more_timer = null;
        if (_this29.mode !== mode || _this29.getPaginationState() !== state || !_this29.isNearBottom()) {
          return;
        }
        // Recheck loading, exhaustion, bootstrap, and manual-retry guards.
        _this29.loadMoreIfNeeded();
      }, 0);
    }
  }, {
    key: "loadMore",
    value: function () {
      var _loadMore = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var _this30 = this;
        var mode, state, cursorsBefore, renderedBefore, cursorBefore, continueLoading, _mode, publicKey, source, rendered, available, result, _result, painted, pending, cursorAdvanced, renderedMore, consumedCachedItems;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              mode = this.mode;
              state = this.getPaginationState();
              if (!(state.loading || state.exhausted || state.error || mode === 'notifications' && this._notifications_bootstrapping || mode === 'timeline' && this._timeline_bootstrapping)) {
                _context1.n = 1;
                break;
              }
              return _context1.a(2);
            case 1:
              // A scroll or peer-arrival load supersedes any queued continuation.
              if (this._load_more_timer !== null) {
                clearTimeout(this._load_more_timer);
                this._load_more_timer = null;
              }
              cursorsBefore = this.getOlderLoadCursors(mode);
              renderedBefore = this.getRenderedItemCount(mode);
              cursorBefore = state.cursor;
              state.loading = true;
              this.syncFeedStatus();
              continueLoading = false;
              _context1.p = 2;
              if (!this.isProfileMode()) {
                _context1.n = 6;
                break;
              }
              _mode = this.mode;
              publicKey = this.active_profile_key;
              source = this.getActiveProfileSource();
              rendered = this.appendProfileBatch();
              if (rendered) {
                _context1.n = 5;
                break;
              }
              _context1.n = 3;
              return this.loadProfileArchivePage();
            case 3:
              if (!(this.mode !== _mode || this.active_profile_key !== publicKey || this.getPaginationState() !== state)) {
                _context1.n = 4;
                break;
              }
              return _context1.a(2);
            case 4:
              this.appendProfileBatch();
            case 5:
              available = this.collectProfileTweets().length;
              state.error = source.error;
              state.exhausted = Boolean(source.exhausted && state.cursor >= available);
              continueLoading = !state.error && !state.exhausted && this.isNearBottom();
              return _context1.a(2);
            case 6:
              if (!(this.mode === 'thread')) {
                _context1.n = 9;
                break;
              }
              _context1.n = 7;
              return ManagerLoadMore.loadMore({
                mode: this.mode,
                mod: this.mod,
                pagination: this.pagination,
                active_thread_id: this.active_thread_id,
                active_signature: this.active_signature
              });
            case 7:
              result = _context1.v;
              if (!(this.mode !== mode || this.pagination.thread !== state)) {
                _context1.n = 8;
                break;
              }
              return _context1.a(2);
            case 8:
              continueLoading = this.applyOlderLoadResult(result);
              return _context1.a(2);
            case 9:
              if (!(this.mode === 'timeline')) {
                _context1.n = 15;
                break;
              }
              this.fillTimelineToViewport();
              if (this.isNearBottom()) {
                _context1.n = 10;
                break;
              }
              return _context1.a(2);
            case 10:
              if (!(this.getUnrenderedTimelineSignatures().length > 0)) {
                _context1.n = 11;
                break;
              }
              continueLoading = true;
              return _context1.a(2);
            case 11:
              _context1.n = 12;
              return this.requestTweetLoad('older', {
                demand_ts: this.oldestRenderedTweetTs()
              });
            case 12:
              _result = _context1.v;
              if (!(this.pagination.timeline !== state)) {
                _context1.n = 13;
                break;
              }
              return _context1.a(2);
            case 13:
              this.mod.resortTimeline();
              painted = this.fillTimelineToViewport();
              if (!_result.failed) {
                _context1.n = 14;
                break;
              }
              state.error = {
                direction: 'older'
              };
              state.exhausted = false;
              return _context1.a(2);
            case 14:
              state.error = null;
              if (!painted && _result.exhausted && this.getUnrenderedTimelineSignatures().length === 0) {
                state.exhausted = true;
              } else if (!_result.exhausted) {
                state.exhausted = false;
              }
              continueLoading = !state.exhausted && this.isNearBottom();
              return _context1.a(2);
            case 15:
              pending = this.sliceUnrendered(this.mod.notifications_timeline, state.cursor, state.batchSize);
              if (!(pending.length > 0)) {
                _context1.n = 16;
                break;
              }
              continueLoading = this.applyOlderLoadResult({
                type: 'notifications',
                direction: 'older',
                added: pending.slice(),
                updated: [],
                ignored: [],
                exhausted: false
              });
              return _context1.a(2);
            case 16:
              _context1.n = 17;
              return new Promise(function (resolve) {
                var settled = false;
                var finish = function finish(result) {
                  if (settled) {
                    return;
                  }
                  settled = true;
                  if (_this30.pagination.notifications !== state) {
                    resolve();
                    return;
                  }
                  continueLoading = _this30.applyOlderLoadResult(result || {
                    type: 'notifications',
                    direction: 'older',
                    added: [],
                    updated: [],
                    ignored: [],
                    exhausted: true
                  }, 'notifications');
                  resolve();
                };
                var timer = setTimeout(function () {
                  finish({
                    type: 'notifications',
                    direction: 'older',
                    added: [],
                    updated: [],
                    ignored: [],
                    exhausted: true
                  });
                }, 12000);
                try {
                  _this30.mod.loadTransactions('notifications', 'older', function (result) {
                    clearTimeout(timer);
                    finish(result);
                  });
                } catch (err) {
                  clearTimeout(timer);
                  finish({
                    type: 'notifications',
                    direction: 'older',
                    added: [],
                    updated: [],
                    ignored: [],
                    exhausted: true
                  });
                }
              });
            case 17:
              _context1.p = 17;
              state.loading = false;
              // A request started before a peer arrived cannot close the reopened feed.
              if (state === this.pagination.timeline && this._peer_history_pending) {
                state.exhausted = false;
              }
              this.syncFeedStatus();
              this.resumePeerHistory();

              // Branches return from try; continuation must be scheduled from finally.
              // Keep thread auto-loading disabled while its helper generates mock replies.
              if (continueLoading && mode !== 'thread' && this.mode === mode && this.getPaginationState() === state && !state.loading && !state.exhausted && !state.error && this.isNearBottom()) {
                cursorAdvanced = Array.from(this.getOlderLoadCursors(mode)).some(function (_ref15) {
                  var _ref16 = _slicedToArray(_ref15, 2),
                    key = _ref16[0],
                    cursor = _ref16[1];
                  return cursorsBefore.has(key) ? cursor < cursorsBefore.get(key) : cursor > 0;
                });
                renderedMore = this.getRenderedItemCount(mode) > renderedBefore;
                consumedCachedItems = mode !== 'timeline' && state.cursor > cursorBefore;
                if (renderedMore || consumedCachedItems || cursorAdvanced) {
                  this.scheduleLoadMore(mode, state);
                }
              }
              return _context1.f(17);
            case 18:
              return _context1.a(2);
          }
        }, _callee1, this, [[2,, 17, 18]]);
      }));
      function loadMore() {
        return _loadMore.apply(this, arguments);
      }
      return loadMore;
    }()
  }, {
    key: "applyOlderLoadResult",
    value: function applyOlderLoadResult(result) {
      var _result$added2;
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.mode;
      var state = this.pagination[mode];
      if ((_result$added2 = result.added) !== null && _result$added2 !== void 0 && _result$added2.length) {
        this.appendLoadedItems(result, mode);
        this.syncFeedStatus();
        return this.mode === mode && this.isNearBottom();
      }

      // A non-empty archive page may contain only transactions already cached
      // locally. Its cursor still advanced, so keep paging until the archive says
      // it is actually exhausted or a visible tweet is found.
      state.exhausted = Boolean(result.exhausted);
      this.syncFeedStatus();
      return this.mode === mode && !state.exhausted && this.isNearBottom();
    }
  }, {
    key: "ensureScrollFooter",
    value: function ensureScrollFooter() {
      return this.ensureFeedStatus();
    }
  }, {
    key: "ensureFeedStatus",
    value: function ensureFeedStatus() {
      var panel = this.getActivePanelElement();
      if (!panel) {
        return null;
      }
      var footer = panel.querySelector('.feed-status');

      // Upgrade leftover terminators from earlier builds.
      if (!footer) {
        panel.querySelectorAll('.feed-end, .scroll-footer').forEach(function (node) {
          return node.remove();
        });
        this.app.browser.addElementToElement(ManagerScrollFooterTemplate(), panel);
        footer = panel.querySelector('.feed-status');
      }
      if (footer && footer.parentNode === panel) {
        panel.appendChild(footer);
      }
      return footer;
    }
  }, {
    key: "getRenderedItemCount",
    value: function getRenderedItemCount() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.mode;
      var panel = this.getActivePanelElement(mode);
      if (!panel) {
        return 0;
      }
      return _toConsumableArray(panel.querySelectorAll('article.tweet, article.notification')).filter(function (el) {
        return !el.closest('.moderate');
      }).length;
    }
  }, {
    key: "hasCompletedInitialLoad",
    value: function hasCompletedInitialLoad() {
      if (this.isProfileMode()) {
        return true;
      }
      if (this.mode === 'timeline') {
        return this.timeline_rendered && !this._timeline_bootstrapping;
      }
      if (this.mode === 'notifications') {
        return this.notifications_rendered && !this._notifications_bootstrapping;
      }
      if (this.mode === 'thread') {
        return true;
      }
      return true;
    }

    /**
     * Mutually exclusive feed UI status:
     * loading | content | empty | end | error
     */
  }, {
    key: "resolveFeedStatus",
    value: function resolveFeedStatus() {
      var state = this.getPaginationState();
      if (this.mode === 'thread' && this.permalink_state) {
        return this.permalink_state.status;
      }
      if (state.loading || this.mode === 'timeline' && this._timeline_bootstrapping || this.mode === 'notifications' && this._notifications_bootstrapping) {
        return 'loading';
      }
      if (state.error) {
        return 'error';
      }
      var count = this.getRenderedItemCount();
      if (count === 0) {
        if (!this.hasCompletedInitialLoad()) {
          return 'loading';
        }
        return 'empty';
      }
      if (state.exhausted) {
        return 'end';
      }
      return 'content';
    }
  }, {
    key: "syncFeedStatus",
    value: function syncFeedStatus() {
      var footer = this.ensureFeedStatus();
      if (!footer) {
        return;
      }
      var status = this.resolveFeedStatus();
      footer.dataset.status = status;
      var message = footer.querySelector('.message');
      var retry = footer.querySelector('.retry');
      var checkAgain = footer.querySelector('.check-again');
      if (message) {
        // Loading is spinner-only — never keep empty/end copy under the loader.
        message.textContent = status === 'loading' || status === 'content' ? '' : this.getFeedStatusMessage(status);
      }
      if (retry) {
        retry.hidden = this.mode === 'timeline' || this.isProfileMode() || status !== 'unavailable' && status !== 'error';
      }
      if (checkAgain) {
        checkAgain.hidden = this.mode !== 'timeline' && !this.isProfileMode() || status !== 'error';
      }
    }
  }, {
    key: "showScrollFooter",
    value: function showScrollFooter() {
      this.syncFeedStatus();
    }
  }, {
    key: "hideScrollFooter",
    value: function hideScrollFooter() {
      this.syncFeedStatus();
    }
  }, {
    key: "syncScrollFooter",
    value: function syncScrollFooter() {
      this.syncFeedStatus();
    }
  }], [{
    key: "isTweetActionTarget",
    value: function isTweetActionTarget(element) {
      if (!element || typeof element.closest !== 'function') {
        return false;
      }
      return Boolean(element.closest('.controls, .show-more, .tool, .gallery'));
    }
  }, {
    key: "resolveClickedSignature",
    value: function resolveClickedSignature(element) {
      if (!element || typeof element.closest !== 'function') {
        return '';
      }
      if (Manager.isTweetActionTarget(element)) {
        return '';
      }
      var tweet = element.closest('article.tweet');
      if (tweet) {
        return tweet.getAttribute('data-id') || '';
      }
      var notification = element.closest('article.notification');
      if (notification) {
        return notification.getAttribute('data-tweet-id') || '';
      }
      return '';
    }
  }]);
}();
module.exports = Manager;